import { AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool } from "amazon-cognito-identity-js";
import AWS from "aws-sdk";
import _ from "lodash";
import request from "superagent";
import { decode, encode } from "url-safe-base64";
import { v4 as uuidv4 } from "uuid";
import Amplify, { Auth } from "aws-amplify";

import * as playerActions from "../actions/playerActions";
import { default as env, default as globals } from "../constants/env";
import PlayerPaths from "../constants/paths/playerPaths";
import browserHistory from "../history";
import * as awsS3 from "../persistence/s3";
import * as s3Actions from "../persistence/s3";
import { searchOrgActivities, initOrgIndex, initHistoryIndex } from "../search/algolia";
import state from "../state/state";
import { initializeSecurityContextV2, logout as handleLogout, refreshCredentials, startCredentialRefreshInterval } from "../utils/securityUtil";
import * as utils from "../utils/utils";
import { getQueryStringParam, setLocalStorage, uncompressResult } from "../utils/utils";
// import { isDev } from "../utils/utils";
import { navigate, resetEditorSessionState, restoreRecoveryDraft } from "./actions";
import { showError, showSuccess } from "./alertActions";
import { getAssignmentScheduleForCurrentUser, getHealthStreamAssignmentScheduleForCurrentUser, initializeScheduling } from "./assignmentActions";
// import { initializeContentManagementV2 } from "./contentManagementActions";
import { initializeDrive, initializeDriveMap } from "./drive";
import { hasMaxActivities, initializeInventoryV2 } from "./inventoryActions";
import { postMessage, sendAssignmentsMessage, sendDebugLogMessage, sendHealthStreamAssignmentsMessage, sendHideModalEditorMessage, sendInventoryAndUserInfoMessage, sendRestoreSession, sendLogoutMessage, sendLogoutCompleteMessage } from "./mobileAppCommunicationActions";
import { initializeOrganizationsV2, /*getLastLoginOrg, TODO*/deleteLastLoginOrg, getPreferences, getOrgId } from "./orgsActions";
import {
	isOrganizationAdministrator,/*, isOrganizationUser*/
	isOrganizationUser
} from "./user";
import { initializeWorkflowParticipants, initializeWorkflows } from "./workflowActions";

import { archiveActivityRecovery, archivePendingLastActivityRecovery, clearLastActivityRecovery, getLastActivity, hasLastActivityRecoveryPending } from "../actions/user";
import { showYesNo, showConfirm } from "../actions/alertActions";

// Stream Chat and initialization
import { StreamChat } from 'stream-chat';  // eslint-disable-line 
import { getJwtTokenStream } from "../utils/securityUtil";  // eslint-disable-line
import { updateUser } from "../utils/streamChatUtils";  // eslint-disable-line

import moment from "moment-timezone";
import { fetchDriveTree } from "../drive/driveTreeBuilder";
import { resetDrive, listDrive } from "../actions/drive";
import { uploadAiFileToS3 } from "../ai/aiAssistant.js";
import { refreshSharesAi } from "./shareActivityActions.js";
import chatClient from "../utils/chatClient.js";
import { getStreamChatUnreadBreakdown as calculateStreamChatUnreadBreakdown } from "../utils/streamChatUnreadUtils";
import { getStreamRetryDelayMs, isStreamRateLimitError } from "../utils/streamRateLimitUtils";
import { logWebLoginSequence } from "../utils/webLoginSequenceLogger";
import { clearMultiTabAuthoringGuard, syncMultiTabAuthoringGuard } from "../utils/multiTabAuthoringGuard";
//const chatClient = StreamChat.getInstance("bymefp455ef2");
// chatClient.setBaseURL('https://chat.stream-io-api.com'); // eslint-disable-line

AWS.config.update({ region: "us-east-1" });

const poolData = {
	UserPoolId: globals.cognito.userPoolId, // Your user pool id here
	ClientId: globals.cognito.clientId, // Your client id here
};

const REMOTE_PLAYER_AUTH_FLOW_ONE_TIME_CODE_V1 = "oneTimeCodeV1";
const REMOTE_PLAYER_AUTH_CODE_PREFIX = "auth-codes";
const DEMO_ROLE_ORG_ID = "75a99644-d769-11ec-8330-069463faa5ff";
const STREAM_CHAT_UNREAD_REFRESH_DEBOUNCE_MS = 300;
const STREAM_CHAT_UNREAD_RETRY_INITIAL_MS = 2000;
const STREAM_CHAT_UNREAD_RETRY_MAX_MS = 30000;

let streamChatUnreadRefreshTimer = null;
let streamChatUnreadRefreshPromise = null;
let streamChatUnreadRefreshQueued = false;
let streamChatUnreadRefreshGeneration = 0;
let streamChatUnreadRetryDelayMs = STREAM_CHAT_UNREAD_RETRY_INITIAL_MS;
let streamChatUnreadRetryAttempt = 0;
let streamChatUnreadRetryBlockedUntil = 0;
let streamChatUnreadRefreshTimerDueAt = 0;
let streamChatUnreadEventSubscription = null;

export function getStreamChatUnreadBreakdown(unreadResponse = {}) {
	return calculateStreamChatUnreadBreakdown(unreadResponse);
}

function resetStreamChatUnreadRefreshState() {
	streamChatUnreadRefreshGeneration += 1;
	if (streamChatUnreadEventSubscription && typeof streamChatUnreadEventSubscription.unsubscribe === "function") {
		try {
			streamChatUnreadEventSubscription.unsubscribe();
		} catch (err) {
			console.warn("Unable to remove the previous Stream Chat unread listener.", err);
		}
	}
	streamChatUnreadEventSubscription = null;
	if (streamChatUnreadRefreshTimer) {
		clearTimeout(streamChatUnreadRefreshTimer);
	}
	streamChatUnreadRefreshTimer = null;
	streamChatUnreadRefreshTimerDueAt = 0;
	streamChatUnreadRefreshPromise = null;
	streamChatUnreadRefreshQueued = false;
	streamChatUnreadRetryDelayMs = STREAM_CHAT_UNREAD_RETRY_INITIAL_MS;
	streamChatUnreadRetryAttempt = 0;
	streamChatUnreadRetryBlockedUntil = 0;
}

async function refreshStreamChatUnreadBreakdown() {
	if (!chatClient || typeof chatClient.getUnreadCount !== "function") {
		return null;
	}

	if (streamChatUnreadRefreshPromise) {
		streamChatUnreadRefreshQueued = true;
		return streamChatUnreadRefreshPromise;
	}
	if (Date.now() < streamChatUnreadRetryBlockedUntil) {
		scheduleStreamChatUnreadBreakdownRefresh(streamChatUnreadRetryBlockedUntil - Date.now());
		return null;
	}

	const refreshGeneration = streamChatUnreadRefreshGeneration;
	const refreshUserId = chatClient.userID || null;
	let refreshPromise;
	refreshPromise = (async () => {
		try {
			// Defer the SDK call one microtask so this promise is registered as the
			// active request even if a mocked or replaced client throws synchronously.
			const unreadResponse = await Promise.resolve().then(() => chatClient.getUnreadCount());
			if (refreshGeneration !== streamChatUnreadRefreshGeneration || refreshUserId !== (chatClient.userID || null)) {
				return null;
			}
			const unreadBreakdown = getStreamChatUnreadBreakdown(unreadResponse);
			state.set(["appState", "streamChat", "jobUnreadByInstanceId"], unreadBreakdown.jobUnreadByInstanceId);
			state.set(["appState", "streamChat", "genericUnreadMessagesCount"], unreadBreakdown.genericUnreadMessagesCount);
			state.set(["appState", "streamChat", "jobUnreadMessagesCount"], unreadBreakdown.jobUnreadMessagesCount);
			streamChatUnreadRetryDelayMs = STREAM_CHAT_UNREAD_RETRY_INITIAL_MS;
			streamChatUnreadRetryAttempt = 0;
			streamChatUnreadRetryBlockedUntil = 0;
			return unreadBreakdown;
		} catch (err) {
			console.warn("Unable to refresh Stream Chat unread categories.", err);
			if (refreshGeneration === streamChatUnreadRefreshGeneration && refreshUserId === (chatClient.userID || null)) {
				const retryDelay = isStreamRateLimitError(err)
					? getStreamRetryDelayMs(err, { attempt: streamChatUnreadRetryAttempt })
					: streamChatUnreadRetryDelayMs;
				streamChatUnreadRetryAttempt += 1;
				streamChatUnreadRetryDelayMs = Math.min(streamChatUnreadRetryDelayMs * 2, STREAM_CHAT_UNREAD_RETRY_MAX_MS);
				streamChatUnreadRetryBlockedUntil = Math.max(streamChatUnreadRetryBlockedUntil, Date.now() + retryDelay);
				scheduleStreamChatUnreadBreakdownRefresh(retryDelay);
			}
			return null;
		} finally {
			if (streamChatUnreadRefreshPromise === refreshPromise) {
				streamChatUnreadRefreshPromise = null;
				if (streamChatUnreadRefreshQueued) {
					streamChatUnreadRefreshQueued = false;
					scheduleStreamChatUnreadBreakdownRefresh();
				}
			}
		}
	})();
	streamChatUnreadRefreshPromise = refreshPromise;

	return streamChatUnreadRefreshPromise;
}

function scheduleStreamChatUnreadBreakdownRefresh(delay = STREAM_CHAT_UNREAD_REFRESH_DEBOUNCE_MS) {
	const now = Date.now();
	const requestedDueAt = now + Math.max(0, Number(delay) || 0);
	const effectiveDueAt = Math.max(requestedDueAt, streamChatUnreadRetryBlockedUntil);

	// Keep an existing earlier timer. In particular, unread events must never
	// replace a server-directed 429 cooldown with the normal 300 ms debounce.
	if (streamChatUnreadRefreshTimer
		&& streamChatUnreadRefreshTimerDueAt >= streamChatUnreadRetryBlockedUntil
		&& streamChatUnreadRefreshTimerDueAt <= effectiveDueAt) {
		return;
	}

	if (streamChatUnreadRefreshTimer) {
		clearTimeout(streamChatUnreadRefreshTimer);
	}

	streamChatUnreadRefreshTimerDueAt = effectiveDueAt;
	streamChatUnreadRefreshTimer = setTimeout(() => {
		streamChatUnreadRefreshTimer = null;
		streamChatUnreadRefreshTimerDueAt = 0;
		refreshStreamChatUnreadBreakdown();
	}, Math.max(0, effectiveDueAt - now));
}

function emitMobilePerfSample(label, durationMs, meta = {}) {
	if (typeof window === "undefined" || !window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== "function") {
		return;
	}

	try {
		window.ReactNativeWebView.postMessage(JSON.stringify({
			method: "perfSample",
			sample: {
				source: "cloud-webview",
				label,
				durationMs,
				meta,
				timestamp: Date.now()
			}
		}));
	} catch (err) {
		console.error("Unable to emit mobile perf sample", err);
	}
}

function startPerfTimer(label, meta = null) {
	const start = Date.now();
	if (meta) {
		console.log(`[perf] ${label}: start`, meta);
	} else {
		console.log(`[perf] ${label}: start`);
	}

	return (extraMeta = null) => {
		const durationMs = Date.now() - start;
		const mergedMeta = _.assign({}, meta || {}, extraMeta || {});
		if (meta || extraMeta) {
			console.log(`[perf] ${label}: ${durationMs}ms`, mergedMeta);
		} else {
			console.log(`[perf] ${label}: ${durationMs}ms`);
		}
		emitMobilePerfSample(label, durationMs, mergedMeta);
		return durationMs;
	};
}

function parseBooleanQueryParam(value) {
	return value === true || value === 1 || value === "1" || value === "true" || value === "yes" || value === "on";
}

function appendQueryParam(uri, key, value) {
	if (!_.isString(uri) || _.isEmpty(uri)) {
		throw new Error("appendQueryParam expects a non-empty URI string.");
	}
	const separator = uri.indexOf("?") !== -1 ? "&" : "?";
	return `${uri}${separator}${key}=${encodeURIComponent(value)}`;
}

const NATIVE_EXTERNAL_SSO_CUSTOM_STATE = "ambifiMobileExternalSso";
const NATIVE_EXTERNAL_SSO_CALLBACK_URL = "ambifi://auth";
const NATIVE_EXTERNAL_SSO_USER_AGENT_TOKEN = "AmbiFiMobileExternalSso/1";
const HCA_HOSTNAME = "hca.ambifi.com";
const HCA_NATIVE_WEBVIEW_SEEN_SS = "hcaNativeMobileWebViewSeen";
const HCA_NATIVE_CLOUD_PORTAL_SS = "hcaNativeCloudPortal";
const HCA_NATIVE_WEBVIEW_SEEN_LS = "hcaNativeMobileWebViewSeen";
const HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS = "hcaNativeSsoLoginRequestId";
const HCA_NATIVE_SSO_LOGIN_REQUEST_LAUNCH_ID_LS = "hcaNativeSsoLoginRequestLaunchId";
const HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS = "hcaNativePostAuthDedupeRecord";
const HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS = "hcaNativeLogoutSuppressAutoSsoUntil";
const HCA_NATIVE_LOGOUT_COMPLETE_NOTIFIED_LS = "hcaNativeLogoutCompleteNotified";
const HCA_NATIVE_FORCE_REAUTH_UNTIL_LS = "hcaNativeForceReauthUntil";
const HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_MS = 30000;
const HCA_NATIVE_FORCE_REAUTH_MS = 15 * 60 * 1000;
const HCA_NATIVE_POST_AUTH_DEDUPE_MS = 60000;
const HCA_NATIVE_POST_AUTH_PERSISTED_DEDUPE_MS = 15000;

function getPostAuthErrorMessage(err) {
	if (_.isNil(err)) {
		return "";
	}

	if (_.isString(err)) {
		return err;
	}

	const message = _.get(err, "message", "");
	if (_.isString(message) && message !== "") {
		return message;
	}

	const asString = `${err}`;
	return asString === "[object Object]" ? "" : asString;
}

function getPostAuthErrorCode(err) {
	return _.toString(_.get(err, "code", "") || _.get(err, "name", "")).toLowerCase();
}

function getRequestErrorMessage(err) {
	const responseMessage = _.get(err, "response.body.message") || _.get(err, "response.body.error");
	if (_.isString(responseMessage) && responseMessage.trim()) {
		return responseMessage;
	}
	if (_.isPlainObject(_.get(err, "response.body"))) {
		try {
			return JSON.stringify(err.response.body);
		} catch (_e) {
			// Fall through to the generic message.
		}
	}
	return getPostAuthErrorMessage(err) || "Request failed.";
}

function buildStreamChatUserId(rawUsername = "") {
	const baseUsername = rawUsername.includes("@") ? rawUsername.split("@")[0] : rawUsername;
	return baseUsername
		.toLowerCase()
		.replace(/[^a-z0-9_-]+/g, "_")
		.replace(/^_+|_+$/g, "")
		|| "ambifi_user";
}

function isPostAuthTransientAbortError(err) {
	const message = getPostAuthErrorMessage(err).toLowerCase();
	const code = getPostAuthErrorCode(err);

	if (typeof navigator !== "undefined" && navigator.onLine === false) {
		return true;
	}

	return message.includes("network error") ||
		message.includes("networkerror") ||
		message.includes("failed to fetch") ||
		message.includes("request has been terminated") ||
		message.includes("the network is offline") ||
		message.includes("origin is not allowed by access-control-allow-origin") ||
		message.includes("page is being unloaded") ||
		message.includes("load failed") ||
		message.includes("timed out") ||
		message.includes("timeout") ||
		message.includes("cors") ||
		message.includes("aborted") ||
		code === "aborterror" ||
		(code === "typeerror" && (message.includes("fetch") || message.includes("network")));
}

function getCurrentPathForAuthLog() {
	if (typeof window === "undefined" || !window.location) {
		return "";
	}

	return `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`;
}

function logSuppressedPostAuthAbort(label, err, meta = {}) {
	const error = getPostAuthErrorMessage(err);
	const logMeta = _.assign({
		error,
		code: getPostAuthErrorCode(err),
		currentPath: getCurrentPathForAuthLog(),
		redirectAfterMagicLink: state.get(["appState", "redirectAfterMagicLink"]) || "",
		magicLinkProcessing: !!state.get(["appState", "magicLinkProcessing"]),
		appInitialized: !!state.get(["appState", "initialized"]),
		userLoggedIn: !!state.get(["user", "loggedIn"])
	}, meta);

	logWebLoginSequence(label, logMeta);
	sendDebugLogMessage("Cloud suppressed transient post-auth request abort", logMeta);
}

function safeDecodeURIComponent(value) {
	try {
		return decodeURIComponent((value || "").replace(/\+/g, " "));
	} catch (err) {
		return value || "";
	}
}

function redactAuthUrlForLog(value) {
	return _.toString(value || "").replace(/([?&#](?:code|state|id_token|access_token|refresh_token|token|callback|url|error_description)=)[^&#]*/gi, "$1[redacted]");
}

function getAuthUrlLogSummary(value) {
	const url = _.toString(value || "");
	let parsedUrl = null;
	try {
		parsedUrl = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://hca.ambifi.com");
	} catch (_err) {
		parsedUrl = null;
	}
	const urlState = parsedUrl ? parsedUrl.searchParams.get("state") : "";

	return {
		url: redactAuthUrlForLog(url),
		host: parsedUrl ? parsedUrl.host : "",
		pathname: parsedUrl ? parsedUrl.pathname : "",
		hasCode: /[?&]code=/i.test(url),
		hasState: /[?&]state=/i.test(url),
		hasError: /[?&]error=/i.test(url),
		hasNativeStateMarker: hasNativeExternalSsoStateValue(urlState)
	};
}

function isHostedUiLogoutUrl(value) {
	const url = _.toString(value || "");
	try {
		const parsedUrl = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://hca.ambifi.com");
		return parsedUrl.pathname.toLowerCase().indexOf("/logout") !== -1;
	} catch (_err) {
		return /\/logout(?:\?|#|$)/i.test(url);
	}
}

function isHostedUiAuthorizeUrl(value) {
	const url = _.toString(value || "");
	try {
		const parsedUrl = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://hca.ambifi.com");
		return parsedUrl.pathname.toLowerCase().indexOf("/oauth2/authorize") !== -1;
	} catch (_err) {
		return /\/oauth2\/authorize(?:\?|#|$)/i.test(url);
	}
}

function isHostedUiNavigationUrl(value) {
	return isHostedUiAuthorizeUrl(value) || isHostedUiLogoutUrl(value);
}

function isNativeHcaForceReauthActive() {
	if (!isHcaHost()) {
		return false;
	}

	const forceUntil = parseInt(utils.getLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS), 10);
	if (!forceUntil || forceUntil <= Date.now()) {
		utils.removeLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS);
		return false;
	}

	return true;
}

function clearNativeHcaForceReauth(reason = "") {
	if (!isHcaHost()) {
		return false;
	}

	const forceUntil = utils.getLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS);
	utils.removeLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS);
	sendDebugLogMessage("Cloud cleared native HCA force reauth marker", {
		reason,
		forceUntil
	});
	return true;
}

function addNativeHcaForceReauthPrompt(url, reason = "") {
	if (!isHostedUiAuthorizeUrl(url) || !isNativeHcaForceReauthActive()) {
		return url;
	}

	try {
		const parsedUrl = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://hca.ambifi.com");
		if (parsedUrl.searchParams.get("prompt") === "login") {
			return url;
		}
		parsedUrl.searchParams.set("prompt", "login");
		const nextUrl = parsedUrl.toString();
		sendDebugLogMessage("Cloud added HCA force reauth prompt to authorize URL", {
			reason,
			authUrl: getAuthUrlLogSummary(nextUrl)
		});
		return nextUrl;
	} catch (err) {
		sendDebugLogMessage("Cloud could not add HCA force reauth prompt", {
			reason,
			error: err && err.message ? err.message : `${err}`,
			authUrl: getAuthUrlLogSummary(url)
		});
		return url;
	}
}

function assignWindowLocation(url, reason = "") {
	const navigationUrl = addNativeHcaForceReauthPrompt(url, reason);
	if (typeof window !== "undefined" && window.location) {
		if (typeof window.location.assign === "function") {
			window.location.assign(navigationUrl);
		} else {
			window.location.href = navigationUrl;
		}
	}
}

function getLocationQueryParam(key) {
	if (typeof window === "undefined" || !window.location || !_.isString(key) || key === "") {
		return "";
	}

	const query = _.toString(window.location.search || "").replace(/^\?/, "");
	if (query === "") {
		return "";
	}

	const pairs = query.split("&");
	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i];
		const separatorIndex = pair.indexOf("=");
		const rawKey = separatorIndex === -1 ? pair : pair.substring(0, separatorIndex);
		if (safeDecodeURIComponent(rawKey) === key) {
			const rawValue = separatorIndex === -1 ? "" : pair.substring(separatorIndex + 1);
			return safeDecodeURIComponent(rawValue);
		}
	}

	return "";
}

function hasOAuthCallbackParams() {
	return getLocationQueryParam("code") !== "" || getLocationQueryParam("error") !== "";
}

function isNativeSsoLoginRequested() {
	return isNativeMobileWebView() && parseBooleanQueryParam(getLocationQueryParam("nativeSsoLogin"));
}

function isNativeMobileAppLaunchRequested() {
	return isNativeMobileWebView() && getLocationQueryParam("app-api-version") !== "";
}

function isNativeCloudPortalMode() {
	if (!isNativeMobileWebView()) {
		return false;
	}

	const currentRequestCloudPortal = parseBooleanQueryParam(getLocationQueryParam("nativeCloudPortal"));
	if (currentRequestCloudPortal) {
		setNativeCloudPortalSessionMarker();
		return true;
	}

	return hasNativeCloudPortalSessionMarker();
}

function getNativeCloudPortalHomePath() {
	const params = new URLSearchParams();
	params.set("nativeCloudPortal", "1");

	const appApiVersion = getLocationQueryParam("app-api-version");
	if (appApiVersion !== "") {
		params.set("app-api-version", appApiVersion);
	}

	const nativeAppLaunchId = getLocationQueryParam("nativeAppLaunchId");
	if (nativeAppLaunchId !== "") {
		params.set("nativeAppLaunchId", nativeAppLaunchId);
	}

	return `/home?${params.toString()}`;
}

function notifyNativeCloudPortalReady(source = "native-cloud-portal", meta = {}) {
	if (!isNativeCloudPortalMode()) {
		return;
	}

	const readyMeta = _.assign({
		source,
		hostname: window.location && window.location.hostname ? window.location.hostname : "",
		pathname: window.location && window.location.pathname ? window.location.pathname : "",
		appApiVersion: getLocationQueryParam("app-api-version")
	}, meta || {});
	sendDebugLogMessage("Cloud native portal ready for mobile sync", readyMeta);
	postMessage({
		method: "nativeCloudPortalReady",
		source: "cloud-webview",
		timestamp: Date.now(),
		meta: readyMeta
	});
}

function getNativeSsoLoginRequestId() {
	const queryRequestId = _.trim(_.toString(getLocationQueryParam("nativeSsoLoginRequestId") || ""));
	if (queryRequestId !== "") {
		return queryRequestId;
	}

	if (!hasDirectNativeMobileBridge() && !hasNativeMobileWebViewSessionMarker() && !hasCurrentRequestNativeMobileMarker()) {
		return "";
	}

	return _.trim(_.toString(utils.getLs(HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS) || ""));
}

function getNativeAppLaunchId() {
	const queryLaunchId = _.trim(_.toString(getLocationQueryParam("nativeAppLaunchId") || ""));
	if (queryLaunchId !== "") {
		return queryLaunchId;
	}

	if (!hasDirectNativeMobileBridge() && !hasNativeMobileWebViewSessionMarker() && !hasCurrentRequestNativeMobileMarker()) {
		return "";
	}

	return _.trim(_.toString(utils.getLs(HCA_NATIVE_SSO_LOGIN_REQUEST_LAUNCH_ID_LS) || ""));
}

function rememberNativeSsoRequestMarkers() {
	if (!isHcaHost() || !isNativeMobileWebView()) {
		return;
	}

	const queryRequestId = _.trim(_.toString(getLocationQueryParam("nativeSsoLoginRequestId") || ""));
	const queryLaunchId = _.trim(_.toString(getLocationQueryParam("nativeAppLaunchId") || ""));
	if (queryRequestId === "" && queryLaunchId === "") {
		return;
	}

	if (queryRequestId !== "") {
		utils.setLs(HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS, queryRequestId);
	}
	if (queryLaunchId !== "") {
		utils.setLs(HCA_NATIVE_SSO_LOGIN_REQUEST_LAUNCH_ID_LS, queryLaunchId);
	}

	sendDebugLogMessage("Cloud remembered native SSO request markers", {
		hasRequestId: queryRequestId !== "",
		nativeAppLaunchId: queryLaunchId
	});
}

function isHcaHost() {
	return typeof window !== "undefined" && window.location && window.location.hostname.toLowerCase() === HCA_HOSTNAME;
}

function hexEncodeString(value) {
	return _.toString(value || "")
		.split("")
		.map(char => char.charCodeAt(0).toString(16).padStart(2, "0"))
		.join("");
}

function hasNativeExternalSsoStateMarker() {
	return hasNativeExternalSsoStateValue(getLocationQueryParam("state"));
}

function hasNativeExternalSsoStateValue(returnedState) {
	if (!returnedState || returnedState.indexOf("-") === -1) {
		return false;
	}

	const customState = returnedState.split("-").slice(1).join("-");
	return customState === hexEncodeString(NATIVE_EXTERNAL_SSO_CUSTOM_STATE);
}

function hasDirectNativeMobileBridge() {
	return !!(
		typeof window !== "undefined" &&
		(
			(window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === "function") ||
			(window.webView && typeof window.webView.postMessage === "function")
		)
	);
}

function hasNativeMobileWebViewSessionMarker() {
	try {
		return typeof window !== "undefined"
			&& window.sessionStorage
			&& window.sessionStorage.getItem(HCA_NATIVE_WEBVIEW_SEEN_SS) === "true";
	} catch (_err) {
		return false;
	}
}

function hasNativeCloudPortalSessionMarker() {
	try {
		return typeof window !== "undefined"
			&& window.sessionStorage
			&& window.sessionStorage.getItem(HCA_NATIVE_CLOUD_PORTAL_SS) === "true";
	} catch (_err) {
		return false;
	}
}

function setNativeMobileWebViewSessionMarker() {
	try {
		if (typeof window !== "undefined" && window.sessionStorage) {
			window.sessionStorage.setItem(HCA_NATIVE_WEBVIEW_SEEN_SS, "true");
		}
	} catch (_err) {
		// Session-only native marker; safe to ignore.
	}
}

function setNativeCloudPortalSessionMarker() {
	try {
		if (typeof window !== "undefined" && window.sessionStorage) {
			window.sessionStorage.setItem(HCA_NATIVE_CLOUD_PORTAL_SS, "true");
		}
	} catch (_err) {
		// Session-only native cloud portal marker; safe to ignore.
	}
}

function clearStaleNativeMobileLocalStorageMarkers() {
	if (!isHcaHost()) {
		return;
	}

	try {
		if (typeof window !== "undefined" && window.sessionStorage) {
			window.sessionStorage.removeItem(HCA_NATIVE_CLOUD_PORTAL_SS);
		}
	} catch (_err) {
		// Session-only native marker; safe to ignore.
	}

	utils.removeLs(HCA_NATIVE_WEBVIEW_SEEN_LS);
	utils.removeLs(HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS);
	utils.removeLs(HCA_NATIVE_SSO_LOGIN_REQUEST_LAUNCH_ID_LS);
	utils.removeLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS);
	utils.removeLs(HCA_NATIVE_LOGOUT_COMPLETE_NOTIFIED_LS);
	utils.removeLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS);
}

function hasCurrentRequestNativeMobileMarker() {
	return getLocationQueryParam("app-api-version") !== ""
		|| getLocationQueryParam("nativeSsoLogin") !== ""
		|| getLocationQueryParam("nativeSsoLoginRequestId") !== ""
		|| getLocationQueryParam("nativeAppLaunchId") !== ""
		|| getLocationQueryParam("nativeCloudPortal") !== "";
}

function isNativeMobileWebView() {
	const hasCurrentMarker = hasCurrentRequestNativeMobileMarker();
	if (isHcaHost() && (hasDirectNativeMobileBridge() || hasCurrentMarker)) {
		setNativeMobileWebViewSessionMarker();
	} else if (isHcaHost() && !hasNativeMobileWebViewSessionMarker()) {
		clearStaleNativeMobileLocalStorageMarkers();
	}

	return !!(hasDirectNativeMobileBridge() || hasCurrentMarker || (isHcaHost() && hasNativeMobileWebViewSessionMarker()));
}

function isNativeExternalSsoCapableWebView() {
	const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
	return isNativeMobileWebView() && _.toString(userAgent).indexOf(NATIVE_EXTERNAL_SSO_USER_AGENT_TOKEN) !== -1;
}

function isNativeCurrentWebViewSsoUrlOpenerAllowed() {
	return isHcaHost()
		&& isNativeMobileWebView()
		&& !isNativeExternalSsoCapableWebView()
		&& (
			parseBooleanQueryParam(getLocationQueryParam("nativeSsoLogin"))
			|| getLocationQueryParam("nativeSsoLoginRequestId") !== ""
		);
}

function isNewNativeMobileSsoPostAuthenticateFlow() {
	return isHcaHost()
		&& isNativeMobileWebView()
		&& !isNativeCloudPortalMode()
		&& (
			isNativeSsoLoginRequested()
			|| getNativeSsoLoginRequestId() !== ""
			|| isNativeExternalSsoCapableWebView()
		);
}

function suppressNativeHcaAutoSignInAfterLogout(reason = "") {
	if (!isHcaHost() || !isNativeMobileWebView()) {
		return false;
	}

	const suppressUntil = Date.now() + HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_MS;
	const forceReauthUntil = Date.now() + HCA_NATIVE_FORCE_REAUTH_MS;
	utils.setLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS, suppressUntil);
	utils.setLs(HCA_NATIVE_FORCE_REAUTH_UNTIL_LS, forceReauthUntil);
	utils.setLs("forceLoginV3", "false");
	sendDebugLogMessage("Cloud suppressing native HCA auto SSO after logout", {
		reason,
		suppressUntil,
		suppressMs: HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_MS,
		forceReauthUntil,
		forceReauthMs: HCA_NATIVE_FORCE_REAUTH_MS
	});
	return true;
}

function clearNativeHcaAutoSignInSuppression(reason = "") {
	if (!isHcaHost()) {
		return false;
	}

	const suppressUntil = utils.getLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS);
	utils.removeLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS);
	utils.removeLs(HCA_NATIVE_LOGOUT_COMPLETE_NOTIFIED_LS);
	utils.setLs("forceLoginV3", "true");
	sendDebugLogMessage("Cloud cleared native HCA auto SSO suppression", {
		reason,
		suppressUntil
	});
	return true;
}

function isNativeHcaAutoSignInSuppressed() {
	if (!isHcaHost() || !isNativeMobileWebView()) {
		return false;
	}

	const suppressUntil = parseInt(utils.getLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS), 10);
	if (!suppressUntil || suppressUntil <= Date.now()) {
		utils.removeLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS);
		return false;
	}

	return true;
}

function notifyNativeHcaLogoutComplete(reason = "") {
	if (!isHcaHost() || !isNativeMobileWebView()) {
		return false;
	}

	utils.setLs(HCA_NATIVE_LOGOUT_COMPLETE_NOTIFIED_LS, "true");
	sendDebugLogMessage("Cloud native HCA logout complete", {
		reason,
		pathname: typeof window !== "undefined" && window.location ? window.location.pathname : "",
		search: typeof window !== "undefined" && window.location ? redactAuthUrlForLog(window.location.search) : "",
		suppressUntil: utils.getLs(HCA_NATIVE_LOGOUT_SUPPRESS_AUTO_SSO_UNTIL_LS)
	});
	sendLogoutCompleteMessage(reason, {
		hcaHost: true,
		suppressedAutoSso: isNativeHcaAutoSignInSuppressed()
	});
	sendHideModalEditorMessage();
	return true;
}

function setNativeHcaSsoRedirectPending(pending, message = "Opening HCA single sign-on...", meta = {}) {
	if (!isHcaHost() || !isNativeMobileWebView()) {
		return;
	}

	const wasPending = !!state.get(["appState", "nativeHcaSsoRedirectPending"]);
	state.set(["appState", "nativeHcaSsoRedirectPending"], !!pending);
	if (pending) {
		state.set(["appState", "loadingMessage"], message);
		utils.showLoader(state);
		postMessage({
			method: "loginStatus",
			label: message
		});
	} else if (wasPending) {
		state.set(["appState", "loadingMessage"], "");
		utils.hideLoader(state);
	}

	sendDebugLogMessage("Cloud native HCA SSO redirect pending state changed", _.assign({
		pending: !!pending,
		message
	}, meta || {}));
}

function redirectNativeExternalSsoCallbackIfNeeded() {
	if (typeof window === "undefined" || isNativeMobileWebView()) {
		return false;
	}

	if (!isHcaHost() || !hasOAuthCallbackParams() || !hasNativeExternalSsoStateMarker()) {
		return false;
	}

	sendDebugLogMessage("Cloud redirecting external SSO callback to native app", getAuthUrlLogSummary(window.location.href));
	window.location.href = appendQueryParam(NATIVE_EXTERNAL_SSO_CALLBACK_URL, "callback", window.location.href);
	return true;
}

function openHostedUiInNativeBrowser(url, redirectUrl) {
	const requestId = `external-sso-${uuidv4()}`;
	if (isHostedUiLogoutUrl(url)) {
		sendDebugLogMessage("Cloud keeping Hosted UI logout in WebView", {
			requestId,
			logoutUrl: getAuthUrlLogSummary(url),
			redirectUrl: getAuthUrlLogSummary(redirectUrl)
		});
		assignWindowLocation(url, "hosted-ui-logout");
		return Promise.resolve();
	}

	const authUrl = addNativeHcaForceReauthPrompt(url, "native-external-sso-browser");
	sendDebugLogMessage("Cloud requesting native external SSO browser", {
		requestId,
		authUrl: getAuthUrlLogSummary(authUrl),
		redirectUrl: getAuthUrlLogSummary(redirectUrl),
		nativeCallbackUrl: NATIVE_EXTERNAL_SSO_CALLBACK_URL
	});

	postMessage({
		method: "startExternalSso",
		requestId,
		url: authUrl,
		redirectUrl,
		nativeCallbackUrl: NATIVE_EXTERNAL_SSO_CALLBACK_URL
	});

	return Promise.resolve();
}

function openHostedUiInCurrentWebView(url, redirectUrl) {
	const authUrl = addNativeHcaForceReauthPrompt(url, "current-webview-url-opener");
	sendDebugLogMessage("Cloud opening Hosted UI in current WebView", {
		authUrl: getAuthUrlLogSummary(authUrl),
		redirectUrl: getAuthUrlLogSummary(redirectUrl),
		hostedUiLogout: isHostedUiLogoutUrl(url)
	});

	assignWindowLocation(authUrl, "current-webview-url-opener");

	return Promise.resolve();
}

function configureNativeSsoUrlOpener(amplifyConfig) {
	const externalSsoCapable = isNativeExternalSsoCapableWebView();
	const currentWebViewSsoAllowed = isNativeCurrentWebViewSsoUrlOpenerAllowed();
	if (!amplifyConfig || !amplifyConfig.oauth || (!externalSsoCapable && !currentWebViewSsoAllowed)) {
		sendDebugLogMessage("Cloud native SSO urlOpener not enabled", {
			nativeMobileWebView: isNativeMobileWebView(),
			nativeExternalSsoCapable: externalSsoCapable,
			currentWebViewSsoAllowed,
			hcaHost: isHcaHost(),
			hasAmplifyConfig: !!amplifyConfig,
			hasOauthConfig: !!(amplifyConfig && amplifyConfig.oauth)
		});
		return amplifyConfig;
	}

	const urlOpener = externalSsoCapable ? openHostedUiInNativeBrowser : openHostedUiInCurrentWebView;
	const mode = externalSsoCapable ? "external-browser" : "current-webview";

	sendDebugLogMessage("Cloud native SSO urlOpener enabled", {
		nativeMobileWebView: isNativeMobileWebView(),
		nativeExternalSsoCapable: externalSsoCapable,
		currentWebViewSsoAllowed,
		hcaHost: isHcaHost(),
		mode
	});

	amplifyConfig.oauth = _.assign({}, amplifyConfig.oauth, {
		urlOpener
	});

	return amplifyConfig;
}

function getHcaFederatedSignInOptions() {
	const options = {
		customProvider: "HCA"
	};

	if (isNativeExternalSsoCapableWebView()) {
		options.customState = NATIVE_EXTERNAL_SSO_CUSTOM_STATE;
	}

	return options;
}

function installHcaNativeWindowOpenRedirectShim(meta = {}) {
	if (!isHcaHost() || !isNativeMobileWebView() || typeof window === "undefined" || typeof window.open !== "function") {
		return () => {};
	}

	const originalWindowOpen = window.open;
	let restored = false;
	const restore = () => {
		if (restored) {
			return;
		}
		restored = true;
		if (window.open === redirectShim) {
			window.open = originalWindowOpen;
		}
	};
	const redirectShim = function redirectShim(url, target, features) {
		if (isHostedUiNavigationUrl(url)) {
			const authUrl = addNativeHcaForceReauthPrompt(url, "window-open-redirect-shim");
			sendDebugLogMessage("Cloud intercepted Hosted UI window.open for native HCA WebView", _.assign({
				url: getAuthUrlLogSummary(authUrl),
				target: target || "",
				nativeMobileWebView: isNativeMobileWebView(),
				nativeExternalSsoCapable: isNativeExternalSsoCapableWebView()
			}, meta || {}));
			assignWindowLocation(authUrl, "window-open-redirect-shim");
			return window;
		}

		return originalWindowOpen.apply(window, arguments);
	};

	window.open = redirectShim;
	setTimeout(restore, 10000);
	return restore;
}

function startHcaFederatedSignIn(meta = {}) {
	logWebLoginSequence("portal.startHcaFederatedSignIn start", {
		nativeMobileWebView: isNativeMobileWebView(),
		nativeExternalSsoCapable: isNativeExternalSsoCapableWebView(),
		source: meta.source || "",
		forceLogin: meta.forceLogin,
		nativeSsoLoginRequested: !!meta.nativeSsoLoginRequested,
		nativeMobileAppLaunchRequested: !!meta.nativeMobileAppLaunchRequested
	});
	sendDebugLogMessage("Cloud starting HCA federated sign-in", _.assign({
		nativeMobileWebView: isNativeMobileWebView(),
		nativeExternalSsoCapable: isNativeExternalSsoCapableWebView(),
		willAttachNativeExternalSsoState: isNativeExternalSsoCapableWebView()
	}, meta));

	const restoreWindowOpen = installHcaNativeWindowOpenRedirectShim(meta);
	try {
		const result = Auth.federatedSignIn(getHcaFederatedSignInOptions());
		logWebLoginSequence("portal.startHcaFederatedSignIn dispatched", {
			source: meta.source || ""
		});
		setTimeout(restoreWindowOpen, 250);
		return result;
	} catch (err) {
		restoreWindowOpen();
		logWebLoginSequence("portal.startHcaFederatedSignIn failed", {
			source: meta.source || "",
			error: err && err.message ? err.message : `${err}`
		});
		throw err;
	}
}

function getRemotePlayerAuthContext(authParams = {}) {
	const authFlow = _.get(authParams, "authFlow", null);
	if (authFlow === REMOTE_PLAYER_AUTH_FLOW_ONE_TIME_CODE_V1) {
		const authCode = uuidv4();
		return {
			authCode,
			tmpCredentialsFilename: `${REMOTE_PLAYER_AUTH_CODE_PREFIX}/${authCode}.json`,
			useOneTimeCodeFlow: true
		};
	}
	return {
		authCode: null,
		tmpCredentialsFilename: `${uuidv4()}.json`,
		useOneTimeCodeFlow: false
	};
}

function runBackgroundInitTask(label, task) {
	Promise.resolve()
		.then(task)
		.catch((err) => {
			console.error(`Deferred init task failed: ${label}`, err);
		});
}

async function connectChatForLoggedInUser({ jwt, username }) {
	if (!state.get(["user", "chatEnabled"])) {
		return;
	}
	resetStreamChatUnreadRefreshState();
	state.set(["appState", "chatConnected"], false);
	state.set(["appState", "streamChat", "genericUnreadMessagesCount"], null);
	state.set(["appState", "streamChat", "jobUnreadMessagesCount"], null);
	state.set(["appState", "streamChat", "jobUnreadByInstanceId"], null);
	state.set(["appState", "streamChat", "unreadMessagesCount"], 0);
	state.set(["appState", "streamChat", "unreadChannelsCount"], 0);

	try {
		const user = state.get(["user"]);
		const rawUsername = user.username || user.email || _.get(user, "attributes.email") || username || "";
		if (!rawUsername) {
			throw new Error("Missing username/email for chat user");
		}
		const newUsername = buildStreamChatUserId(rawUsername);
		const selectedOrgId = state.get(["selectedOrg", "id"]) || "";

		console.log("$#$#$# USERNAME", rawUsername, newUsername);
		const userToken = await getJwtTokenStream(jwt, newUsername);

		const isAdmin = isOrganizationAdministrator();

		await updateUser(jwt, newUsername, user.name, rawUsername.toLowerCase(), user.profilePicture, isAdmin ? "admin" : "user", user.identityId, selectedOrgId);
		let chatUser;
		try {
			chatUser = await chatClient.connectUser({ id: newUsername, team: selectedOrgId, image: user.profilePicture && user.profilePicture !== "" ? user.profilePicture : null, identityId: user.identityId }, userToken);
		} catch (err) {
			console.log("!@!@!@", err.message, err);
		}
		if (chatUser) {
			console.log(`!@!@!@ you have ${chatUser.me.total_unread_count} unread messages on ${chatUser.me.unread_channels} channels.`);
			state.set(["appState", "streamChat", "unreadMessagesCount"], chatUser.me.total_unread_count);
			state.set(["appState", "streamChat", "unreadChannelsCount"], chatUser.me.unread_channels);
			const listenerGeneration = streamChatUnreadRefreshGeneration;
			const listenerUserId = chatClient.userID || null;
			streamChatUnreadEventSubscription = chatClient.on(event => {
				if (listenerGeneration !== streamChatUnreadRefreshGeneration || listenerUserId !== (chatClient.userID || null)) {
					return;
				}
				if (event.total_unread_count !== undefined) {
					console.log(`!@!@!@ unread messages count is now: ${event.total_unread_count}`);
					state.set(["appState", "streamChat", "unreadMessagesCount"], event.total_unread_count);
					if (Number(event.total_unread_count) === 0) {
						state.set(["appState", "streamChat", "jobUnreadByInstanceId"], {});
						state.set(["appState", "streamChat", "genericUnreadMessagesCount"], 0);
						state.set(["appState", "streamChat", "jobUnreadMessagesCount"], 0);
					}
				}

				if (event.unread_channels !== undefined) {
					console.log(`!@!@!@ unread channels count is now: ${event.unread_channels}`);
					state.set(["appState", "streamChat", "unreadChannelsCount"], event.unread_channels);
				}

				// `unread_count` is scoped to a single channel, while
				// `total_unread_count` is global. Refresh the category totals for
				// either kind of unread event without conflating those two values.
				if (event.type === "connection.recovered"
					|| event.total_unread_count !== undefined
					|| event.unread_count !== undefined
					|| event.unread_channels !== undefined) {
						scheduleStreamChatUnreadBreakdownRefresh(event.type === "connection.recovered" ? 0 : undefined);
				}
			});
			// The connection-level aggregate is already trustworthy. Let the UI
			// load visible job channels while the more detailed category request
			// resolves (or retries) in the background.
			state.set(["appState", "chatConnected"], true);
			await refreshStreamChatUnreadBreakdown();
		}
	} catch (err) {
		state.set(["appState", "chatConnected"], false);
		showError("Chat", "Error connecting to chat.\n\n" + getRequestErrorMessage(err));
	}
}

async function cacheRemotePlayerAuthPayload(tmpCredentialsFilename, authPayload, jwtToken, options = {}) {
	const {
		allowDirectS3Fallback = true
	} = options;
	const cacheEndpoint = `${env.apiGateway.baseUrl}${env.apiGateway.endpoints.user.auth}/cache`;
	try {
		await request.post(cacheEndpoint)
			.set({ Authorization: jwtToken, "Content-Type": "application/json" })
			.send(JSON.stringify({
				tmpCredentialsFilename,
				authPayload
			}));
	} catch (err) {
		if (allowDirectS3Fallback) {
			console.warn("Failed to cache auth payload through auth API, falling back to direct S3 upload", err);
			await awsS3.uploadObject(authPayload, env.s3.tmpCredentialsBucket, tmpCredentialsFilename, true);
		} else {
			throw err;
		}
	}
}

export function signUp(user) {
	state.set("user", user);

	registerUser(_.toLower(user.username), user.password, _.toLower(user.email), user.name);
}

export function setUsername(tree, username) {
	tree.set(["user", "username"], _.toLower(username));
}

export function verifyUser(username, code) {
	confirmRegisteredUser(username, code);
}

export function resendVerifyCode(username) {
	setUsername(state, username);
	resendConfirmation(username);
}

export function forgotPasswordForUser(username) {
	forgotPassword(username);
}

export function changeForgottenPasswordForUser(username, code, newPassword) {
	changeForgottenPassword(username, code, newPassword);
}

export function login(tree) {
	const username = tree.get(["user", "username"]);
	const password = tree.get(["user", "password"]);
	try {
		clearUser();
	} catch (e) {
		console.warn("Failed to clear previous credentials", e);
	}
	const currentPathname = _.toString(_.get(window, "location.pathname", ""));
	if (currentPathname === "/auth" || currentPathname.indexOf("/auth/") === 0) {
		authenticateUser(tree, username, password);
	} else {
		loginUser(tree, username, password);
	}
}

export function upload() {
	//uploadToS3();
}
export function uploadFile(file) {
	s3Actions.uploadFileToS3("", "", file.name);
}

export function uploadAiFile(bucket, keyPrefix, file) {
	return uploadAiFileToS3(bucket, keyPrefix, file);
}

export function uploadFiles(files) {
	if (hasMaxActivities()) {
		return;
	}

	s3Actions.uploadFilesToS3(globals.s3.contentBucket, files);
}


export async function uploadFilesFromContentReview(files, srcFormat, options = {}) {
	return s3Actions.uploadFilesFromContentReviewToS3(globals.s3.contentBucket, files, srcFormat, options);
}

export async function uploadFilesFromOrgImport(files, method) {
	await s3Actions.uploadFilesFromOrgImportToS3(globals.s3.contentBucket, files, method);
}

export function uploadMediaFile(file, fileName, type) {
	return s3Actions.uploadMediaFileToS3(globals.s3.converterBucket, file, fileName, type);
}

export function logout() {
	logoutUser(state.get(["user", "username"]));
}

function startsOrEndsWithWhitespace(str) {
	if (str === "") {
		return false;
	} else {
		return /^\s|\s$/.test(str);
	}
}



function registerUser(username, password, email, name, nickname = "", website = "", profile = "", picture = "") {
	if (startsOrEndsWithWhitespace(username)) {
		alert("There is a leading or trailing space on the Username. Please correct this.");
		return;
	}
	if (startsOrEndsWithWhitespace(password)) {
		alert("There is a leading or trailing space on the Password. Please correct this.");
		return;
	}
	if (startsOrEndsWithWhitespace(email)) {
		alert("There is a leading or trailing space on the Email. Please correct this.");
		return;
	}
	if (startsOrEndsWithWhitespace(name)) {
		alert("There is a leading or trailing space on the Name. Please correct this.");
		return;
	}

	let userPool = new CognitoUserPool(poolData);

	let attributeList = [];

	let dataEmail = {
		Name: "email",
		Value: email
	};

	let dataName = {
		Name: "name",
		Value: name
	};

	let attributeEmail = new CognitoUserAttribute(dataEmail);
	let attributeName = new CognitoUserAttribute(dataName);

	attributeList.push(attributeEmail);
	attributeList.push(attributeName);

	let dataNickname = {
		Name: "nickname",
		Value: nickname
	};

	let attributeNickname = new CognitoUserAttribute(dataNickname);
	attributeList.push(attributeNickname);

	let dataWebsite = {
		Name: "website",
		Value: website
	};

	let attributeWebsite = new CognitoUserAttribute(dataWebsite);
	attributeList.push(attributeWebsite);

	let dataProfile = {
		Name: "profile",
		Value: profile
	};

	let attributeProfile = new CognitoUserAttribute(dataProfile);
	attributeList.push(attributeProfile);

	let dataPicture = {
		Name: "picture",
		Value: picture
	};

	let attributePicture = new CognitoUserAttribute(dataPicture);
	attributeList.push(attributePicture);

	userPool.signUp(username, password, attributeList, null, function (err, result) {
		if (err) {
			if (err.code === "InvalidPasswordException" || (err.code === "InvalidParameterException" && err.message.toLowerCase().includes("password"))) {
				alert("Make sure your password has a minimum of 8 characters, and at least one uppecase character, one lowercase character and one numeral.");
			} else {
				alert(err.message);
			}
			return;
		}
		let cognitoUser = result.user;
		console.log("user name is " + cognitoUser.getUsername());

		browserHistory.push(globals.routes.verify);
	});
}

function resendConfirmation(username) {

	let userPool = new CognitoUserPool(poolData);
	let userData = {
		Username: _.toLower(username),
		Pool: userPool
	};

	let cognitoUser = new CognitoUser(userData);

	cognitoUser.resendConfirmationCode(function (err) {
		if (err) {
			showError("Resend confirmation", `There was a problem resending the confirmation code: ${err.message}`);
			return;
		}

		browserHistory.push(globals.routes.verify);
	});
}

function confirmRegisteredUser(username, code) {

	let userPool = new CognitoUserPool(poolData);
	let userData = {
		Username: _.toLower(username),
		Pool: userPool
	};

	let cognitoUser = new CognitoUser(userData);
	cognitoUser.confirmRegistration(code, true, function (err, result) {
		if (err) {
			showError("Account confirmation", `There was a problem confirming your account: ${err.message}`);
			return;
		}

		console.log("call result: " + result);

		browserHistory.push(globals.routes.login);
	});
}

function forgotPassword(username) {

	let userPool = new CognitoUserPool(poolData);
	let userData = {
		Username: _.toLower(username),
		Pool: userPool
	};

	let cognitoUser = new CognitoUser(userData);
	cognitoUser.forgotPassword({
		onSuccess: function (result) {
			console.log("call result: " + result);
		},
		onFailure: function (err) {
			showError("Password reset", `There was a problem requesting the password reset: ${err.message}`);
		},
		//Optional automatic callback
		inputVerificationCode: function (data) {
			console.log("Code sent to: " + data);
			browserHistory.push(globals.routes.forgotPassword);
		}
	});
}

function changeForgottenPassword(username, code, newPassword) {

	let userPool = new CognitoUserPool(poolData);
	let userData = {
		Username: _.toLower(username),
		Pool: userPool
	};

	let cognitoUser = new CognitoUser(userData);
	cognitoUser.confirmPassword(code, newPassword, {
		onSuccess: function onSuccess() {
			showSuccess("Password Reset", "Your password was successfully reset!");
			browserHistory.push(globals.routes.login);
		},
		onFailure: function onFailure(err) {
			showError("Password reset", `There was a problem resetting your password. ${err.message}`);
		}
	});
}

async function updateAttribute(cognitoUser, name, value) {
	try {
		if (cognitoUser) {
			const params = {
				[name]: _.isString(value) ? value : JSON.stringify(value)
			};
			await Auth.updateUserAttributes(cognitoUser, params);
		}
	} catch (e) {
		console.error("Failed to update user attribute...", name, value, e);
		// alert(e);
	}
}

function deviceExists(device, devices) {
	for (let i = 0; i < devices.length; i++) {
		if (device.deviceId === devices[i].deviceId) {
			return true;
		}
	}

	return false;
}

export function updateItunesSubscription(itunesSubscription) {
	refreshCredentials().then(({ cognitoUser }) => {
		updateAttribute(cognitoUser, "custom:itunesSubscription", itunesSubscription);
	}).catch((err) => {
		console.error(err);
		alert(err.message);
	});
}

async function initializeUserAttributes(cognitoUser) {
	return new Promise(async (resolve) => {
		const userAttributes = _.get(cognitoUser, "idToken.payload");
		console.log("Initialize user attributes", userAttributes);

		// Set initially all empty
		state.set(["user", "email"], "");
		state.set(["user", "emailChatNotify"], true);
		state.set(["user", "phone_number"], "");
		state.set(["user", "phoneNumChatNotify"], false);
		state.set(["user", "profilePicture"], "");

		let params = {
			AccessToken: cognitoUser.accessToken.jwtToken
		};
		let cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

		const user = await cognitoidentityserviceprovider.getUser(params).promise();

		for (let i = 0; i < user.UserAttributes.length; i++) {
			const userAttrib = user.UserAttributes[i];
			if (userAttrib.Name === "email") {
				userAttributes.email = userAttrib.Value;
			} else if (userAttrib.Name === "custom:emailChatNotify") {
				userAttributes["custom:emailChatNotify"] = userAttrib.Value;
			} else if (userAttrib.Name === "phone_number") {
				userAttributes["phone_number"] = userAttrib.Value;
			} else if (userAttrib.Name === "custom:phoneNumChatNotify") {
				userAttributes["custom:phoneNumChatNotify"] = userAttrib.Value;
			} else if (userAttrib.Name === "custom:profilePicture") {
				userAttributes["custom:profilePicture"] = userAttrib.Value;
			}
		}

		state.set(["user", "nickname"], "");
		state.set(["user", "website"], "");
		state.set(["user", "profile"], "");
		state.set(["user", "picture"], "");
		if (!userAttributes) {
			resolve();
			return;
		}
		_.keys(userAttributes).forEach(key => {
			const userAttrValue = userAttributes[key];
			if (key === "email_verified") {
				state.set(["user", "emailVerified"], userAttrValue);
			} else if (key === "custom:emailChatNotify") {
				state.set(["user", "emailChatNotify"], (userAttrValue && userAttrValue !== "") ? userAttrValue.toLowerCase() === "true" : false);
			} else if (key === "custom:phoneNumChatNotify") {
				state.set(["user", "phoneNumChatNotify"], (userAttrValue && userAttrValue !== "") ? userAttrValue.toLowerCase() === "true" : false);
			} else if (key === "custom:subscriptionId") {
				state.set(["user", "subscriptionId"], userAttrValue);
			} else if (key === "custom:profilePicture") {
				state.set(["user", "profilePicture"], userAttrValue);
			} else if (key === "custom:subscriptionPlan") {
				const plan = state.get(["user", "subscriptionPlan"]);

				if (plan === null) {
					state.set(["user", "subscriptionPlan"], userAttrValue);
				} else {
					if (plan !== "pro-plan-monthly-itunes" && plan !== "pro-plan-yearly-itunes") {
						state.set(["user", "subscriptionPlan"], userAttrValue);
					}
				}
			} else if (key === "custom:deviceLimit") {
				state.set(["user", "deviceLimit"], Number(userAttrValue));
			} else if (key === "custom:stripeCustomerId") {
				state.set(["user", "stripeCustomerId"], userAttrValue);
			} else if (key === "custom:devices") {
				if (userAttrValue.length > 0) {

					state.set(["devices"], JSON.parse(userAttrValue));
					console.log(JSON.stringify(state.get(["devices"])));
				}
			} else if (key === "custom:itunesSubscription") {
				if (userAttrValue.length > 0) {
					// Only if not already a pro plan
					//if (!state.get(["subscription"]).startsWith("pro")) {
					let sub = JSON.parse(userAttrValue);
					state.set(["user", "subscriptionPlan"], sub.plan);
					state.set(["user", "subscriptionExpiration"], sub.expiration);
					//}
				}
			} else if (key === "custom:devicesBlacklist") {
				if (userAttrValue.length > 0) {
					postMessage(JSON.parse(userAttrValue));
				}
			} else if (key === "custom:historyUpdated") {
				state.set(["user", "historyUpdated"], userAttrValue === "true");
			} else if (key === "sub") {
				// THIS IS NEW - use "sub" as the identity id
				// state.set(["user", "identityId"], userAttrValue); 

				// HSC (08/21/2020) The above line was commented out because we used to use the Cognito users "sub" as the
				// main identifier in AmbiFi - the problem used to be the lack of flexibility. In that a Cognito user had to exist
				// in order to add a user to a group or assign to a user. PLUS a huge issue is user transition - if a user moves from
				// one identity provider to another, for example we transition a user group to their own Active Directory!

				state.set(["user", "_injected_security_credentials", "iid"], userAttrValue);
				state.set(["user", "sub"], userAttrValue);
			} else {
				state.set(["user", key], userAttrValue);
			}
		});

		console.log("$#$#$# STATE", state);

		resolve();
	});
}

function finishUserinitialization(cognitoUser) {
	const user = state.get(["user"]);

	if (!user.hasOwnProperty("historyUpdated") || !user.historyUpdated) {
		awsS3.touchHistoryFiles(user.identityId);
	}

	if (!user.hasOwnProperty("subscriptionPlan")) {
		const subscriptionPlan = env.config.defaultPlan;
		state.set(["user", "subscriptionPlan"], subscriptionPlan);
		updateAttribute(cognitoUser, "custom:subscriptionPlan", subscriptionPlan);
	} else if (isOrganizationAdministrator()) {
		let newHistoryUsers = [];

		let member = state.get(["selectedOrg", "member"]);
		newHistoryUsers.push({ identityId: member.userSubId, name: member.displayName });

		let members = state.get(["selectedOrg", "members"]);
		for (let i = 0; i < members.length; i++) {
			if (member.userSubId !== members[i].userSubId) {
				newHistoryUsers.push({ identityId: members[i].userSubId, name: members[i].displayName });

			}
		}

		state.set(["user", "historyUsers"], newHistoryUsers);
	}

	console.log("$#$#$# STATE", state);
}

function initializeDevices(cognitoUser, username) {
	return new Promise((resolve, reject) => {
		try {
			let redirectRemoveDevices = false;

			// if sso login we should call endpoint, otherwise do everything below
			state.set(["user", "username"], username);

			let user = state.get(["user"]);

			const maxDevices = user.hasOwnProperty("deviceLimit") ? user.deviceLimit : 5;

			if (!user.hasOwnProperty("historyUpdated") || !user.historyUpdated) {
				awsS3.touchHistoryFiles(user.identityId);
			}

			let currentDevice = state.get(["device"]);
			let devices = state.get(["devices"]);
			let deviceFound = false;
			// If device array is empty then add and good to go
			// Check if the current device is in the devices array
			// If it is we are good to go
			// If it is not then redirect to remove a device
			if (currentDevice !== null) {
				if (!user.hasOwnProperty("subscriptionPlan")) {
					if (!deviceExists(currentDevice, devices)) {
						devices.push(currentDevice);
						updateAttribute(cognitoUser, "custom:devices", devices);
					}
				} else if (user.subscriptionPlan === "basic-plan" && devices.length < 1) {
					if (!deviceExists(currentDevice, devices)) {
						devices.push(currentDevice);
						updateAttribute(cognitoUser, "custom:devices", devices);
					}
				} else if (user.subscriptionPlan === "basic-plan-checkmate" && devices.length < 3) {
					if (!deviceExists(currentDevice, devices)) {
						devices.push(currentDevice);
						updateAttribute(cognitoUser, "custom:devices", devices);
					}
					//} else if (user.subscriptionPlan.substring( 0, "standard-plan".length ) === "standard-plan" && devices.length < 3) {
				} else if (user.subscriptionPlan.startsWith("standard-plan") && devices.length < 3) {
					if (!deviceExists(currentDevice, devices)) {
						devices.push(currentDevice);
						updateAttribute(cognitoUser, "custom:devices", devices);
					}
				} else if (user.subscriptionPlan.startsWith("pro-plan") && (devices.length < maxDevices || maxDevices === 0)) {
					//} else if (user.subscriptionPlan.substring( 0, "pro-plan".length ) === "pro-plan" && devices.length < 5) {
					if (!deviceExists(currentDevice, devices) && maxDevices !== 0) {
						devices.push(currentDevice);
						updateAttribute(cognitoUser, "custom:devices", devices);
					}
				} else {
					for (let i = 0; i < devices.length; i++) {
						let device = devices[i];
						if (currentDevice.deviceId === device.deviceId) {
							deviceFound = true;
						}
					}

					redirectRemoveDevices = !deviceFound;
				}
			}

			resolve(redirectRemoveDevices);
		} catch (e) {
			console.error("Failed to initialize devices for user", username, e);
			reject(e);
		}

	});
}

let callAlertTimeout;

let nativePostAuthenticateDedupeRecord = null;

function getNativePostAuthenticatePersistedDedupeRecord() {
	try {
		const rawRecord = utils.getLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS);
		if (!rawRecord) {
			return null;
		}

		const record = _.isString(rawRecord) ? JSON.parse(rawRecord) : rawRecord;
		if (!_.isPlainObject(record) || !record.key) {
			utils.removeLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS);
			return null;
		}

		if (record.expiresAt && Number(record.expiresAt) <= Date.now()) {
			utils.removeLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS);
			return null;
		}

		return record;
	} catch (_err) {
		utils.removeLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS);
		return null;
	}
}

function setNativePostAuthenticatePersistedDedupeRecord(record) {
	if (!_.isPlainObject(record) || !record.key) {
		return;
	}

	try {
		utils.setLs(HCA_NATIVE_POST_AUTH_DEDUPE_RECORD_LS, JSON.stringify(record));
	} catch (_err) {
		// Best-effort duplicate guard only.
	}
}

function getNativePostAuthenticateDedupeKey(username = "") {
	if (!isNewNativeMobileSsoPostAuthenticateFlow()) {
		return "";
	}

	const requestId = getNativeSsoLoginRequestId();
	if (requestId !== "") {
		return `hca-native-sso:${requestId}:${getNativeAppLaunchId() || "no-launch-id"}:${_.toString(username || "")}`;
	}

	const stateParam = getLocationQueryParam("state");
	if (isNativeExternalSsoCapableWebView() && stateParam !== "") {
		return `hca-native-external-sso:${stateParam}:${getNativeAppLaunchId() || "no-launch-id"}:${_.toString(username || "")}`;
	}

	return "";
}

export async function handlePostAuthenticateV2(loginResult, cognitoUser, tree, username) {
	const dedupeKey = getNativePostAuthenticateDedupeKey(username);
	const dedupeRequestId = getNativeSsoLoginRequestId();
	const dedupeLaunchId = getNativeAppLaunchId();
	const now = Date.now();
	const persistedDedupeRecord = dedupeKey ? getNativePostAuthenticatePersistedDedupeRecord() : null;
	if (dedupeKey && persistedDedupeRecord && persistedDedupeRecord.key === dedupeKey) {
		sendDebugLogMessage("Cloud skipped duplicate native post-auth run from persisted marker", {
			dedupeKey,
			launchId: dedupeLaunchId,
			ageMs: now - Number(persistedDedupeRecord.completedAt || persistedDedupeRecord.startedAt || now),
			expiresAt: persistedDedupeRecord.expiresAt || null
		});
		setNativeHcaSsoRedirectPending(false, "", {
			source: "native-post-auth-persisted-dedupe"
		});
		sendHideModalEditorMessage();
		return Promise.resolve();
	}
	if (dedupeKey && nativePostAuthenticateDedupeRecord && nativePostAuthenticateDedupeRecord.key === dedupeKey && now - nativePostAuthenticateDedupeRecord.startedAt < HCA_NATIVE_POST_AUTH_DEDUPE_MS) {
		sendDebugLogMessage("Cloud skipped duplicate native post-auth run", {
			dedupeKey,
			inFlight: !nativePostAuthenticateDedupeRecord.completedAt,
			ageMs: now - nativePostAuthenticateDedupeRecord.startedAt
		});
		return nativePostAuthenticateDedupeRecord.promise;
	}

	const postAuthenticatePromise = runPostAuthenticateV2(loginResult, cognitoUser, tree, username);
	if (!dedupeKey) {
		return postAuthenticatePromise;
	}

	nativePostAuthenticateDedupeRecord = {
		key: dedupeKey,
		startedAt: now,
		completedAt: 0,
		promise: postAuthenticatePromise
	};
	postAuthenticatePromise
		.then(() => {
			const completedAt = Date.now();
			if (nativePostAuthenticateDedupeRecord && nativePostAuthenticateDedupeRecord.key === dedupeKey) {
				nativePostAuthenticateDedupeRecord.completedAt = completedAt;
			}
			setNativePostAuthenticatePersistedDedupeRecord({
				key: dedupeKey,
				requestId: dedupeRequestId,
				launchId: dedupeLaunchId,
				completedAt,
				expiresAt: completedAt + HCA_NATIVE_POST_AUTH_PERSISTED_DEDUPE_MS
			});
		})
		.catch(err => {
			if (nativePostAuthenticateDedupeRecord && nativePostAuthenticateDedupeRecord.key === dedupeKey) {
				nativePostAuthenticateDedupeRecord.completedAt = Date.now();
			}
			sendDebugLogMessage("Cloud native post-auth run failed", {
				dedupeKey,
				error: err && err.message ? err.message : `${err}`
			});
		});
	setTimeout(() => {
		if (nativePostAuthenticateDedupeRecord && nativePostAuthenticateDedupeRecord.key === dedupeKey) {
			if (dedupeRequestId !== "" && utils.getLs(HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS) === dedupeRequestId) {
				utils.removeLs(HCA_NATIVE_SSO_LOGIN_REQUEST_ID_LS);
				utils.removeLs(HCA_NATIVE_SSO_LOGIN_REQUEST_LAUNCH_ID_LS);
			}
			nativePostAuthenticateDedupeRecord = null;
		}
	}, HCA_NATIVE_POST_AUTH_DEDUPE_MS);
	return postAuthenticatePromise;
}

async function runPostAuthenticateV2(loginResult, cognitoUser, tree, username) {
	const nativeCloudPortalMode = isNativeCloudPortalMode();
	const nativeMobileBridge = utils.isMobile();
	const mobileAppLoginMode = nativeMobileBridge && !nativeCloudPortalMode;
	const nativeAppLaunchId = getNativeAppLaunchId();
	const nativeSsoLoginRequestId = getNativeSsoLoginRequestId();
	const newNativeMobileLoginHandoff = mobileAppLoginMode && nativeAppLaunchId !== "" && nativeSsoLoginRequestId !== "";
	logWebLoginSequence("portal.runPostAuthenticateV2 start", {
		mobileAppLoginMode,
		nativeMobileBridge,
		nativeCloudPortalMode,
		newNativeMobileLoginHandoff,
		nativeAppLaunchId: nativeAppLaunchId || "",
		hasNativeSsoLoginRequestId: nativeSsoLoginRequestId !== "",
		userEntryPoint: state.get(["user", "entryPoint"]) || "",
		navPanelSelected: state.get(["appState", "navPanel", "selected"]),
		appInitialized: state.get(["appState", "initialized"])
	});
	const endPostAuthenticate = startPerfTimer("cloud.session.handlePostAuthenticateV2", {
		username,
		isMobile: nativeMobileBridge,
		nativeCloudPortalMode,
		mobileAppLoginMode,
		newNativeMobileLoginHandoff,
		nativeAppLaunchId
	});
	if (mobileAppLoginMode) {
		postMessage({
			method: "showSpinnerForLogin"
		});
	}

	utils.showLoader(tree);

	console.log("handlePostAuthenticateV2", loginResult);
	setLocalStorage("loginDetected", true);

	const endInitializeUserAttributes = startPerfTimer("cloud.session.initializeUserAttributes");
	await initializeUserAttributes(loginResult);
	endInitializeUserAttributes();
	const endInitializeDevices = startPerfTimer("cloud.session.initializeDevices");
	const redirectRemoveDevices = await initializeDevices(cognitoUser, username);
	endInitializeDevices({
		redirectRemoveDevices: !!redirectRemoveDevices
	});

	if (redirectRemoveDevices) {
		endPostAuthenticate({
			result: "redirectRemoveDevices"
		});
		utils.hideLoader(tree);
		alert("You have too many devices registered.", () => {
			browserHistory.push(globals.routes.devices);
		});
	} else {
		finishUserinitialization(cognitoUser);
		try {
			if (mobileAppLoginMode) {
				postMessage({
					method: "loginStatus",
					label: "Preparing session..."
				});
			}
			const endUserInitAuth = startPerfTimer("cloud.session.userInitAuth");
			const res = await request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.userInitAuth}`)
				.set({ Authorization: loginResult.idToken.jwtToken, "Content-Type": "application/json" })
				.send(JSON.stringify({}));
			endUserInitAuth();

				const userData = res.body;
				console.log("Got:", userData);
				logWebLoginSequence("portal.userInitAuth returned", {
					hasFederationTokenBuilderResult: !!(userData && userData.federationTokenBuilderResult),
					workflowCount: _.isArray(userData && userData.workflows) ? userData.workflows.length : _.keys((userData && userData.workflows) || {}).length,
					timerTemplateCount: _.isArray(userData && userData.timerTemplates) ? userData.timerTemplates.length : _.keys((userData && userData.timerTemplates) || {}).length
				});

			const organizationLoadingMessage = nativeCloudPortalMode ? "Opening AmbiFi Cloud..." : "Loading organization...";
			state.set(["appState", "loadingMessage"], organizationLoadingMessage);
			if (mobileAppLoginMode) {
				postMessage({
					method: "loginStatus",
					label: organizationLoadingMessage
				});
			}

			let jwt = loginResult.idToken.jwtToken;
			const endFetchOrgInfo = startPerfTimer("cloud.session.fetchOrgInfo");
				let orgs = await fetchOrgInfo(jwt);
				endFetchOrgInfo({
					orgCount: _.isArray(orgs) ? orgs.length : 0
				});
				logWebLoginSequence("portal.fetchOrgInfo returned", {
					orgCount: _.isArray(orgs) ? orgs.length : 0,
					orgId: _.get(orgs, "0.id", ""),
					memberIdPresent: !!_.get(orgs, "0.member.userSubId", null),
					displayNamePresent: !!_.get(orgs, "0.member.displayName", null)
				});

			if (Array.isArray(orgs) && orgs.length > 0 && orgs[0].id === "5418b78a-ea0c-11eb-9068-066917b38554" && cognitoUser.username.toLowerCase() !== "hca.admin") {
				// HCA org, we need to delete the last login org
				alert("You are not allowed to login to this organization. Please contact your administrator.");

				state.set(["appState", "loadingMessage"], "");
				if (mobileAppLoginMode) {
					postMessage({
						method: "loginStatus",
						label: ""
					});
				}

				utils.hideLoader(tree);
				endPostAuthenticate({
					result: "blockedOrg"
				});

				return;
			}

			// Get display name
			const displayName = _.get(orgs, "0.member.displayName", null);
			if (!displayName) {
				throw new Error({
					message: "Unable to obtain displayName from logged in user."
				});
			}
			state.set(["user", "displayName"], displayName);
			// state.set(["user", "name"], displayName);

			const chatEnabled = _.get(orgs, "0.member.chatEnabled", false);
			state.set(["user", "chatEnabled"], chatEnabled === 1 ? true : false);

			// Get timezone
			let timeZone = _.get(orgs, "0.member.timeZone", null);

			if (!timeZone || timeZone === "") {
				timeZone = moment.tz.guess();
			}

			if (!timeZone) {
				throw new Error({
					message: "Unable to obtain timezone from logged in user."
				});
			}
			state.set(["user", "timeZone"], timeZone);

			// Now to fetch the member info and finish the logged in user state
			const userSubId = _.get(orgs, "0.member.userSubId", null);
			if (!userSubId) {
				throw new Error({
					message: "Unable to obtain userSubId from logged in user."
				});
			}

			// alert(userSubId);
			state.set(["user", "identityId"], userSubId);

			console.log("Setting remember me", tree.get(["user", "username"]), tree.get(["user", "rememberMe"]));
			utils.setLs(tree.get(["user", "username"]) + ";rememberMe", tree.get(["user", "rememberMe"]));

			const { /*contentModels,*/
				//drive,
				federationTokenBuilderResult,
				//orgs,
				schedules,
				timerTemplates,
				workflows,
				workflowParticipants,
				//inventory
			} = userData;

			if (mobileAppLoginMode) {
				postMessage({
					method: "loginStatus",
					label: "Securing session..."
				});
			}
			const endInitializeSecurityContext = startPerfTimer("cloud.session.initializeSecurityContextV2");
			await initializeSecurityContextV2(cognitoUser, federationTokenBuilderResult, loginResult);
			endInitializeSecurityContext();
			console.log("Initialized Security Context");

			const endInitializeOrganizations = startPerfTimer("cloud.session.initializeOrganizationsV2");
			await initializeOrganizationsV2(orgs);
			syncMultiTabAuthoringGuard();
			endInitializeOrganizations({
				orgCount: _.isArray(orgs) ? orgs.length : 0
			});
			console.log("Initialized Org Info");

			const currentRequestedPath = `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`;
			const isAdminLogsPath = _.isString(currentRequestedPath) && (currentRequestedPath.indexOf("/adminLogs") === 0 || currentRequestedPath.indexOf("/authReports") === 0);
			const isInfinityInspirePath = _.isString(currentRequestedPath) && currentRequestedPath.indexOf("/infinityInspire") === 0;
			if (!mobileAppLoginMode && !nativeCloudPortalMode && isAdminLogsPath) {
				state.set(["timerTemplates"], timerTemplates);
				state.set(["user", "loggedIn"], true);
				state.set(["appState", "initialized"], true);
				state.set(["appState", "loadingMessage"], "");
				state.set(["appState", "navPanel", "selected"], "adminLogs");
				state.set(["user", "entryPoint"], currentRequestedPath);
				utils.removeLs("origin");
				startCredentialRefreshInterval();
				logWebLoginSequence("portal admin logs route initialized", {
					currentRequestedPath,
					orgCount: _.isArray(orgs) ? orgs.length : 0
				});
				endPostAuthenticate({
					result: "adminLogsReady"
				});
				utils.hideLoader(tree);
				return;
			}
			if (!mobileAppLoginMode && !nativeCloudPortalMode && isInfinityInspirePath) {
				state.set(["appState", "navPanel", "selected"], "infinityInspire");
				state.set(["user", "entryPoint"], currentRequestedPath);
				utils.removeLs("origin");
			}

			const apiVersion = getQueryStringParam("app-api-version");
			const deferInventoryParam = parseBooleanQueryParam(getQueryStringParam("deferInventory"));
			const homeVisible = state.get(["appCapabilities", "views", "nav", "homeVisible"]);
			const deferInventoryForHome = nativeCloudPortalMode && homeVisible;
			const deferInventoryForMobile = mobileAppLoginMode && apiVersion >= 8 && deferInventoryParam;

			// Make sure org and history index is initialized for Algolia
			const deferOrgHistoryAndChatInit = deferInventoryForMobile || nativeCloudPortalMode;
			if (deferOrgHistoryAndChatInit) {
				runBackgroundInitTask("Initialize org/history search index", async () => {
					const endOrgHistoryInit = startPerfTimer("cloud.session.initOrgAndHistoryIndex.background");
					await initOrgIndex();
					await initHistoryIndex();
					endOrgHistoryInit();
				});
				runBackgroundInitTask("Connect chat", async () => {
					const endConnectChat = startPerfTimer("cloud.session.connectChat.background");
					await connectChatForLoggedInUser({ jwt, username });
					endConnectChat();
				});
			} else {
				const endOrgHistoryInit = startPerfTimer("cloud.session.initOrgAndHistoryIndex");
				await initOrgIndex();
				await initHistoryIndex();
				endOrgHistoryInit();
				const endConnectChat = startPerfTimer("cloud.session.connectChat");
				await connectChatForLoggedInUser({ jwt, username });
				endConnectChat();
			}

			let inventory = [];

			if ((mobileAppLoginMode && isOrganizationUser() && apiVersion >= 8) || deferInventoryForMobile) {
				// No Op
			} else {
				const endInitializeWorkflows = startPerfTimer("cloud.session.initializeWorkflows", {
					workflowCount: _.isArray(workflows) ? workflows.length : _.keys(workflows || {}).length
				});
				await initializeWorkflows(workflows); // Before inventory
				endInitializeWorkflows();
				console.log("Initialized Workflows");
				const endInitializeWorkflowParticipants = startPerfTimer("cloud.session.initializeWorkflowParticipants", {
					participantCount: _.isArray(workflowParticipants) ? workflowParticipants.length : _.keys(workflowParticipants || {}).length
				});
				await initializeWorkflowParticipants(workflowParticipants); // Before inventory
				endInitializeWorkflowParticipants();
				console.log("Initialized Workflow Participants");

				if (!deferInventoryForHome) {
					state.set(["appState", "loadingMessage"], "Loading inventory...");
					if (mobileAppLoginMode) {
						postMessage({
							method: "loginStatus",
							label: "Loading inventory..."
						});
					}

					const endFetchInventory = startPerfTimer("cloud.session.fetchInventory");
					let fullInventory = await fetchInventory(jwt);
					endFetchInventory({
						inventoryCount: _.get(fullInventory, "inventory.length", 0)
					});
					inventory = fullInventory.inventory;

					const endInitializeInventory = startPerfTimer("cloud.session.initializeInventoryV2", {
						inventoryCount: _.isArray(inventory) ? inventory.length : 0
					});
					await initializeInventoryV2(inventory);
					endInitializeInventory();
					console.log("Initialized Inventory");
				}
			}

					const deferWebRouteInitialization = !mobileAppLoginMode && !nativeCloudPortalMode;
					state.set(["timerTemplates"], timerTemplates);
					state.set(["user", "loggedIn"], true);
					if (!deferWebRouteInitialization) {
						state.set(["appState", "initialized"], true);
					}
					logWebLoginSequence("portal user marked logged in", {
						userEntryPoint: state.get(["user", "entryPoint"]) || "",
						navPanelSelected: state.get(["appState", "navPanel", "selected"]),
						homeVisible: state.get(["appCapabilities", "views", "nav", "homeVisible"]),
						deferInventoryForHome,
						deferInventoryForMobile,
						appInitialized: state.get(["appState", "initialized"]),
						deferWebRouteInitialization
					});
				startCredentialRefreshInterval();

			const finalizeCloudSessionInit = async () => {
				const endFinalizeCloudSession = startPerfTimer("cloud.session.finalizeCloudSessionInit");
				const endRefreshSharesAi = startPerfTimer("cloud.session.refreshSharesAi");
				await refreshSharesAi();
				endRefreshSharesAi();

				const endGetPreferences = startPerfTimer("cloud.session.getPreferences");
				const prefs = await getPreferences();
				endGetPreferences();

				if (prefs.preferences && prefs.preferences.playlists) {
					state.set(["playlists"], prefs.preferences.playlists);
				}

				if (mobileAppLoginMode && !deferInventoryForMobile) {
					postMessage({
						method: "loginStatus",
						label: "Loading scheduling..."
					});
				}

				const endInitializeScheduling = startPerfTimer("cloud.session.initializeScheduling");
				await initializeScheduling(schedules);
				endInitializeScheduling();
				console.log("Initialized Scheduling");

				if (!mobileAppLoginMode && getOrgId() === "75a99644-d769-11ec-8330-069463faa5ff") {
					getHealthStreamAssignmentScheduleForCurrentUser().then(assignments => {
						state.set(["assignmentsHealthStream"], assignments);
					});
				}

				const endGetPrintTemplates = startPerfTimer("cloud.session.getPrintTemplates");
				const templates = await s3Actions.getPrintTemplates();
				endGetPrintTemplates({
					templateCount: _.isArray(templates) ? templates.length : 0
				});

				let filteredTemplates = [];
				for (let i = 0; i < templates.length; i++) {
					const template = templates[i];
					if (template.name.startsWith("ambifi-")) {
						filteredTemplates.push(template);
					}
				}

				state.set(["printTemplates"], filteredTemplates);
				console.log("Initialized Print Templates");
				endFinalizeCloudSession({
					filteredTemplateCount: filteredTemplates.length
				});
			};

				const deferFinalCloudSessionInit = deferInventoryForMobile || nativeCloudPortalMode;
				if (deferFinalCloudSessionInit) {
					logWebLoginSequence("portal deferred final cloud session init", {
						nativeCloudPortalMode,
						deferInventoryForMobile
					});
					runBackgroundInitTask(
						nativeCloudPortalMode ? "Initialize native cloud portal session" : "Initialize deferred mobile cloud session",
						finalizeCloudSessionInit
					);
				} else {
					await finalizeCloudSessionInit();
				}
				if (nativeCloudPortalMode) {
					endPostAuthenticate({
						result: "nativeCloudPortalReady",
						inventoryCount: _.isArray(inventory) ? inventory.length : 0
					});
					state.set(["appState", "initialized"], true);
					state.set(["appState", "nativeCloudPortalSessionRestoring"], false);
					state.set(["appState", "nativeCloudPortalSessionRestoreFailed"], false);
					state.set(["appState", "navPanel", "selected"], "home");
					state.set(["user", "entryPoint"], "/home");
					utils.removeLs("origin");
					notifyNativeCloudPortalReady("nativeCloudPortalReady", {
						inventoryCount: _.isArray(inventory) ? inventory.length : 0
					});
					utils.hideLoader(tree);
					browserHistory.replace(getNativeCloudPortalHomePath());
					return;
				}
			const isPreviewPopoutPath = _.isString(currentRequestedPath) && currentRequestedPath.indexOf("/preview-popout") === 0;
			if (isPreviewPopoutPath) {
				endPostAuthenticate({
					result: "previewPopoutReady",
					inventoryCount: _.isArray(inventory) ? inventory.length : 0
				});
				utils.hideLoader(tree);
				return;
			}
			if (mobileAppLoginMode) {
				console.log("Mobile");
				// const apiVersion = getQueryStringParam("app-api-version");

				console.log("!#!#!# INVENTORY", inventory);

				if (mobileAppLoginMode) {
					postMessage({
						method: "loginStatus",
						label: "Handing off to mobile app..."
					});
				}
				sendInventoryAndUserInfoMessage(inventory).then(async () => {
					if (mobileAppLoginMode) {
						postMessage({
							method: "loginStatus",
							label: "Waiting for mobile app to finish..."
						});
					}


					// if (apiVersion > 3) {

					const ambifiAssignments = getAssignmentScheduleForCurrentUser();
					sendAssignmentsMessage(ambifiAssignments);

					// Shoud we do the same for HealthStream assignments
					// Only for HCA
					if (getOrgId() === "75a99644-d769-11ec-8330-069463faa5ff") {
						sendDebugLogMessage("Cloud loading HealthStream assignments in background");
						getHealthStreamAssignmentScheduleForCurrentUser()
							.then(hsAssignments => {
								sendDebugLogMessage("Cloud sent HealthStream assignments payload", {
									assignmentCount: _.isArray(hsAssignments) ? hsAssignments.length : 0
								});
								sendHealthStreamAssignmentsMessage(hsAssignments);
							})
							.catch(err => {
								console.error("Unable to load HealthStream assignments during mobile login", err);
								logWebLoginSequence("portal mobile HealthStream assignments failed", {
									error: err && err.message ? err.message : `${err}`
								});
							});
					}

					sendHideModalEditorMessage();

						endPostAuthenticate({
							result: deferInventoryForMobile ? "mobileSessionInitializedDeferredInventory" : "mobileSessionInitialized",
							inventoryCount: _.isArray(inventory) ? inventory.length : 0
						});

						if (newNativeMobileLoginHandoff) {
							sendDebugLogMessage("Cloud completed new native mobile login handoff; preparing cloud landing", {
								nativeAppLaunchId,
								nativeSsoLoginRequestId,
								deferInventoryForMobile
							});
						}

						// }
						// if (apiVersion > 4) {
						// 	sendOrganizationInfoMessage(orgs);
					// }
					setTimeout(function () {
						if (deferInventoryForMobile) {
							state.set(["appState", "initialized"], true);
							state.set(["appState", "navPanel", "selected"], "home");
							state.set(["user", "entryPoint"], "/home");
							utils.removeLs("origin");
							browserHistory.replace("/home");
							return;
						}

						navigate(true);
					}, 1000);
				}).catch(err => {
					endPostAuthenticate({
						result: "mobileInventoryError",
						error: getPostAuthErrorMessage(err)
					});
					console.error(err);
					if (isPostAuthTransientAbortError(err)) {
						logSuppressedPostAuthAbort("portal mobile inventory transient request aborted", err, {
							phase: "sendInventoryAndUserInfoMessage",
							mobileAppLoginMode,
							nativeMobileBridge,
							nativeCloudPortalMode,
							newNativeMobileLoginHandoff,
							nativeAppLaunchId: nativeAppLaunchId || "",
							hasNativeSsoLoginRequestId: nativeSsoLoginRequestId !== ""
						});
					} else {
						showError("Mobile Inventory", "Failed to build mobile inventory of activities, this might be due to network connectivity issues.");
					}
					utils.hideLoader(tree);
				});
				} else {
					console.log("Not mobile");
					logWebLoginSequence("portal web post-auth branch", {
						homeVisible,
						deferInventoryForHome,
						userEntryPoint: state.get(["user", "entryPoint"]) || "",
						navPanelSelected: state.get(["appState", "navPanel", "selected"]),
						currentPath: `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`
					});
					if (homeVisible) {
					console.log("Home visible / Initialize player");
					state.set(
						PlayerPaths.SELECTED_HOME_TAB,
						(state.get(["appState", "demoRole"]) === "leader" && getOrgId() === DEMO_ROLE_ORG_ID) ? "team" : "myActivities"
					);
					if (deferInventoryForHome) {
						state.set(["activities"], []);
						state.set(PlayerPaths.ACTIVITIES, []);
						state.set(PlayerPaths.SESSIONS, {});
						state.set(PlayerPaths.ACTIVITIES_LOADED, false);
						state.set(PlayerPaths.RELOAD_ACTIVITIES, false);
					}
					const initializeHomeActivities = deferInventoryForHome
						? Promise.resolve()
						: playerActions.initializePlayer(inventory);
						initializeHomeActivities.then(async () => {
							if (deferWebRouteInitialization) {
								state.set(["appState", "initialized"], true);
								logWebLoginSequence("portal web route initialization released", {
									currentPath: `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`,
									pendingOrigin: utils.getLs("origin") || "",
									navPanelSelected: state.get(["appState", "navPanel", "selected"])
								});
							}
							endPostAuthenticate({
								result: deferInventoryForHome ? "webHomeInitializedDeferredInventory" : "webHomeInitialized",
								inventoryCount: _.isArray(inventory) ? inventory.length : 0
							});
							notifyNativeCloudPortalReady("webHomeInitialized", {
								deferInventoryForHome,
								inventoryCount: _.isArray(inventory) ? inventory.length : 0
							});
							// This can be set as an alternative target to MyChecklists
							// When a user without anything in their inventory logs in they should see
							// either the org search index (to add to their inventory), OR the public
						// search index ... much like YouTube
						console.log("here1");
						let altMyChecklistsTarget = null;

						// let hasNonLearningActivities = false;
						// if (inventory && _.isArray(inventory)) {
						// 	inventory.forEach(act => {
						// 		if (!act.category || act.category !== "learning") {
						// 			hasNonLearningActivities = true;
						// 		}
						// 	});
						// }

						console.log("here2");
						// if (!hasNonLearningActivities) {
						// 	console.log("Empty inventory ... ", inventory);
						// 	let numActivities = [];
						// 	try {
						// 		numActivities = await searchOrgActivities();
						// 	} catch (err) {
						// 		// This will happen for an empty org index, if it has never been used
						// 		console.warn("Err testing org index", err);
						// 	}
						// 	// const orgActivities = await searchOrgActivities();
						// 	altMyChecklistsTarget = "/search";
						// 	if (numActivities > 0) {
						// 		// Check to see if public activities
						// 		state.set(["appState", "searchInitialTab"], "org");
						// 	}
						// }

							console.log("here3");
							let lastActivity = getLastActivity();
							const pendingOrigin = utils.getLs("origin");
							const redirectAfterMagicLink = state.get(["appState", "redirectAfterMagicLink"]);
						const hasPendingRedirect = (
							(_.isString(pendingOrigin) && pendingOrigin !== "" && pendingOrigin !== "/login" && pendingOrigin !== "/") ||
							(_.isString(redirectAfterMagicLink) && redirectAfterMagicLink !== "")
							);
							logWebLoginSequence("portal web post-auth choosing route", {
								lastActivityPending: !!(lastActivity && _.isObject(lastActivity) && lastActivity.hasOwnProperty("type")),
								pendingOrigin: pendingOrigin || "",
								redirectAfterMagicLink: redirectAfterMagicLink || "",
								hasPendingRedirect,
								altMyChecklistsTarget,
								userEntryPoint: state.get(["user", "entryPoint"]) || ""
							});
							if (hasPendingRedirect) {
								console.log("Skipping restore prompt because a redirect target is pending", pendingOrigin || redirectAfterMagicLink);
								logWebLoginSequence("portal web post-auth navigate due to pending redirect", {
									pendingOrigin: pendingOrigin || "",
									redirectAfterMagicLink: redirectAfterMagicLink || "",
									altMyChecklistsTarget
								});
								utils.hideLoader(tree);
								navigate(true, altMyChecklistsTarget);
								return;
						}
						if (lastActivity && _.isObject(lastActivity) && lastActivity.hasOwnProperty("type")) {
							// navigate(true, altMyChecklistsTarget);
							console.log("here4a");
							showYesNo("It looks like you may not have properly exited the editor. You have an activity named <b>" + lastActivity.name + "</b> that can be restored.<br/<br/><br/>If you decide to restore you will get a chance to review the activity before deciding if you want to save it. If you choose No, it will stay available under Recover Drafts on the Authoring screen.", "Do you want to restore it?", async (yes) => {
								console.log("here4b");
								if (yes) {
									const retainedInRecoveryArchive = archiveActivityRecovery(lastActivity, "restored_from_portal_restore_prompt");
									const restoredActivity = await restoreRecoveryDraft(lastActivity, {
										clearPendingRecovery: true,
										removeArchivedRecovery: false,
										showRestoredNotice: true,
										retainedInRecoveryArchive
									});

									navigate(true, "/editor/" + restoredActivity.id);
								} else {

									console.log("here4");
									const archived = archivePendingLastActivityRecovery("dismissed_from_portal_restore_prompt");
									if (!archived && !hasLastActivityRecoveryPending()) {
										clearLastActivityRecovery();
									}
									navigate(true, altMyChecklistsTarget);
								}
							});
							} else {

								console.log("here5");
								logWebLoginSequence("portal web post-auth navigate default", {
									altMyChecklistsTarget,
									userEntryPoint: state.get(["user", "entryPoint"]) || ""
								});
								navigate(true, altMyChecklistsTarget);
							}

					}).catch((err) => {
						endPostAuthenticate({
							result: "webHomeInitializeError",
							error: getPostAuthErrorMessage(err)
						});
						console.error("Load Activities", err, err.stack);
						const isAbort = isPostAuthTransientAbortError(err);
						const redirectPending = state.get(["appState", "redirectAfterMagicLink"]) || state.get(["appState", "magicLinkProcessing"]);
						if (isAbort) {
							logSuppressedPostAuthAbort("portal web home transient request aborted", err, {
								phase: "initializeHomeActivities",
								mobileAppLoginMode,
								nativeMobileBridge,
								nativeCloudPortalMode,
								newNativeMobileLoginHandoff,
								nativeAppLaunchId: nativeAppLaunchId || "",
								hasNativeSsoLoginRequestId: nativeSsoLoginRequestId !== ""
							});
						} else if (!redirectPending) {
							showError("Load Activities", "Unable to load activities, this might be due to network connectivity issues.");
						}
						utils.hideLoader(tree);
					});
						} else {

							console.log("here6");
							console.log("Home not visible");
							logWebLoginSequence("portal web post-auth home hidden navigate", {
								userEntryPoint: state.get(["user", "entryPoint"]) || "",
								navPanelSelected: state.get(["appState", "navPanel", "selected"])
							});
							endPostAuthenticate({
							result: "webSessionInitializedNoHome",
							inventoryCount: _.isArray(inventory) ? inventory.length : 0
						});
						notifyNativeCloudPortalReady("webSessionInitializedNoHome", {
							inventoryCount: _.isArray(inventory) ? inventory.length : 0
						});
						navigate(true);
					}
				}
		} catch (err) {
			endPostAuthenticate({
				result: "error",
				error: getPostAuthErrorMessage(err)
			});
			console.error("Failed to retrieve user info after login.", err);

			utils.hideLoader(tree);
			const isAbort = isPostAuthTransientAbortError(err);
			const redirectPending = state.get(["appState", "redirectAfterMagicLink"]) || state.get(["appState", "magicLinkProcessing"]);
			if (isAbort) {
				logSuppressedPostAuthAbort("portal post-auth transient request aborted", err, {
					phase: "runPostAuthenticateV2",
					mobileAppLoginMode,
					nativeMobileBridge,
					nativeCloudPortalMode,
					newNativeMobileLoginHandoff,
					nativeAppLaunchId: nativeAppLaunchId || "",
					hasNativeSsoLoginRequestId: nativeSsoLoginRequestId !== ""
				});
			} else if (!_.get(err, "handled", false) && !redirectPending) {
				showError("Error Retrieving User Info", "An error occurred while attempting to get user info such as inventory, drive content and similar information after a successful login, reason: " + err);
			}
		}

	}


}

// function createUserDoc(tree, username, bucket, keyPrefix) {
// 	// Shouldn't need to add to S3 now 
// 	const _username = _.toLower(username);
// 	const _bucket = new AWS.S3({ useDualStack: true, params: { Bucket: globals.s3.contentBucket, ResponseContentType: "application/json" , ResponseCacheControl: "no-cache" } });

// 	// First check if bucket exists for user...if not create
// 	_bucket.getObject({ Key: keyPrefix + "/user.json" }, function (err) {
// 		if (err) {
// 			let putBatch = function putBatch(files) {
// 				return Promise.all(files.map(function (file) {
// 					let body;
// 					if (file === "user.json") {
// 						let user = _.cloneDeep(state.get(["user"]));
// 						delete user.loggedIn;
// 						delete user.password;
// 						delete user.code;
// 						delete user.email_verified;
// 						body = JSON.stringify(user);
// 					}

// 					return _bucket.putObject({ Key: keyPrefix + "/" + file, ContentType: "application/json", Body: body }).promise();
// 				}));
// 			};

// 			let files = ["user.json"];

// 			putBatch(files)
// 				.then(function () {
// 					s3Actions.getChecklistsCollection(tree, _username, _bucket, keyPrefix, []);
// 					state.set(["user", "loggedIn"], true);
// 				})
// 				.catch((e) => {
// 					console.error("Error putiing user!", e);
// 				});

// 		} else {
// 			// TODO: Could compare user attributes and update if necessary
// 			s3Actions.getChecklistsCollection(tree, _username, _bucket, keyPrefix, []);
// 			state.set(["user", "loggedIn"], true);
// 		}
// 	});
// }

export function handleChangePassword(tree, password) {
	tree.set(["user", "password"], password);

	if (password !== "") {
		let sharedDevice = false;
		if (this && this.props && this.props.user.hasOwnProperty("sharedDevice")) {
			sharedDevice = this.props.user.sharedDevice;
		}

		tree.set(["user", "rememberMe"], !sharedDevice);
		utils.setLs(tree.get(["user", "username"]) + ";rememberMe", !sharedDevice);
		tree.set(["user", "savePassword"], !sharedDevice);
		utils.setLs(tree.get(["user", "username"]) + ";savePassword", !sharedDevice);
	}

	tree.commit();
}

export function handleChangeUsername(tree, username) {
	tree.set(["user", "username"], username);
	tree.commit();
}

export function handleCheckSavePassword(tree, savePassword) {
	tree.set(["user", "savePassword"], savePassword);
	utils.setLs(tree.get(["user", "username"]) + ";savePassword", savePassword);
}

export function handleCheckRememberMe(tree, rememberMe) {
	tree.set(["user", "rememberMe"], rememberMe);
	utils.setLs(tree.get(["user", "username"]) + ";rememberMe", rememberMe);
}

function validateAndParseAuthParams(authParams) {
	if (_.isEmpty(authParams)) {
		throw new Error("auth parameters can not be empty");
	}
	let params = null;

	try {
		params = JSON.parse(atob(decode(authParams)));
	} catch (e) {
		throw new Error("Expecting auth parameters to be a valid Object");
	}

	let validationErrors = [];

	if (!params.hasOwnProperty("redirectUri") || _.isEmpty(params.redirectUri) || !_.isString(params.redirectUri)) {
		validationErrors.push(new Error("Expecting a redirect URI parameter that communicates where to redirect to after successful auth."));
	}

	if (!_.isEmpty(validationErrors)) {
		throw validationErrors;
	}

	return params;
}

/**
 * This function will be used for links that require auth but this wo't go through the whole login process.
 * @param {*} tree 
 * @param {*} username 
 * @param {*} password 
 */
function authenticateUser(tree = state, username, password) {
	return new Promise(async (resolve, reject) => {
		console.log("About to authenticte user");
		const authParams = getQueryStringParam("auth");
		let _authParams = null;
		try {
			_authParams = validateAndParseAuthParams(authParams);
		} catch (e) {
			console.error(e);
			reject(e);
		}

		if (_authParams) {
			try {
				const _username = _.toLower(username);
				let authenticationData = {
					Username: _username,
					Password: password,
				};
				let authenticationDetails = new AuthenticationDetails(authenticationData);
				console.log("About to login");
				const loginResult = await authenticateUserWithBackoff(authenticationDetails);
				console.log("Successfully logged in");

				const {
					authCode,
					tmpCredentialsFilename,
					useOneTimeCodeFlow
				} = getRemotePlayerAuthContext(_authParams);
				const fedTokenEndpoint = `${env.apiGateway.baseUrl}${env.apiGateway.endpoints.auth}`;
				const fedTokenRequestBody = useOneTimeCodeFlow ? {} : { tmpCredentialsFilename };
				const _fedTokenResponse = await request.post(fedTokenEndpoint)
					.set({ Authorization: loginResult.signInUserSession.idToken.jwtToken, "Content-Type": "application/json" })
					.send(JSON.stringify(fedTokenRequestBody));
				const fedTokenResponse = _fedTokenResponse.body;

				const { redirectUri } = _authParams;
				let _redirectUri = redirectUri;
				const identityId = _.get(loginResult, "idToken.payload.sub", null);

				const authCallback = {
					success: true,
					tmpCredentials: fedTokenResponse.body,
					tmpCredentialsFilename,
					tmpCredentialsBucket: env.s3.tmpCredentialsBucket
				};

				const authPayload = {
					success: true,
					loginResult,
					tokens: {
						id: loginResult.signInUserSession.idToken.jwtToken,
						refresh: loginResult.signInUserSession.refreshToken.token
					},
					fedTokenResponse,
					fedTokenEndpoint,
					cognito: {
						ClientId: globals.cognito.clientId
					},
					identityId
				};

				AWS.config.credentials = new AWS.Credentials(fedTokenResponse.body.accessKeyId, fedTokenResponse.body.secretAccessKey, fedTokenResponse.body.sessionToken);
				await cacheRemotePlayerAuthPayload(tmpCredentialsFilename, authPayload, loginResult.signInUserSession.idToken.jwtToken, {
					allowDirectS3Fallback: !useOneTimeCodeFlow
				});

				if (useOneTimeCodeFlow) {
					_redirectUri = appendQueryParam(redirectUri, "authCode", authCode);
				} else {
					_redirectUri = appendQueryParam(redirectUri, "authCallbackV2", encode(btoa(JSON.stringify(authCallback))));
				}
				utils.hideLoader(tree);
				window.location.href = `${_redirectUri}`;
				resolve(loginResult);

			} catch (err) {
				console.log("Login Failure", err);
				utils.hideLoader(tree);
				let message = "Please verify your credentials and try again, you can also use the forgot password link to reset your password.";
				if (err.code && err.code === "NetworkError") {
					message = "Network connection failed, please check your internet connection and try again.";
				}
				showError("Login Unsuccessful", message, () => {
					reject(err);
				});
			}
		} else {
			let message = "Unable to perform operation, missing required parameters for authentication process.";
			showError("Login Unsuccessful", message, () => {
				reject(message);
			});
		}

	});

}

function doAuthenticateUserPromisified(authenticationDetails) {
	return new Promise(async (resolve, reject) => {
		try {
			const result = await Auth.signIn(authenticationDetails);
			resolve(result);
		} catch (err) {
			reject(err);
		}
	});
}

/**
 * Special function with backoff retry
 */
function authenticateUserWithBackoff(authenticationDetails) {
	return new Promise((resolve, reject) => {
		let loginSuccess = false;
		let lastException = null;
		let timeoutException = false;
		let result = null;
		try {
			result = doAuthenticateUserPromisified(authenticationDetails);
			loginSuccess = true;
		} catch (e) {
			timeoutException = e && e.code && e.code === "TooManyRequestsException";
			lastException = e;
			console.error(e);
		}

		if (loginSuccess) {
			resolve(result);
			return;
		} else if (!timeoutException) {
			reject(lastException);
			return;
		} else {
			//Backoff 1
			loginSuccess = false;
			lastException = null;
			timeoutException = false;
			result = null;
			setTimeout(() => {
				try {
					result = doAuthenticateUserPromisified(authenticationDetails);
					loginSuccess = true;
				} catch (e) {
					timeoutException = e && e.code && e.code === "TooManyRequestsException";
					lastException = e;
					console.error(e);
				}

				if (loginSuccess) {
					resolve(result);
					return;
				} else if (!timeoutException) {
					reject(lastException);
					return;
				} else {
					//Backoff 2
					loginSuccess = false;
					lastException = null;
					timeoutException = false;
					result = null;
					setTimeout(() => {
						try {
							result = doAuthenticateUserPromisified(authenticationDetails);
							loginSuccess = true;
						} catch (e) {
							timeoutException = e && e.code && e.code === "TooManyRequestsException";
							lastException = e;
							console.error(e);
						}

						if (loginSuccess) {
							resolve(result);
							return;
						} else if (!timeoutException) {
							reject(lastException);
							return;
						} else {
							//Backoff 3 
							loginSuccess = false;
							lastException = null;
							timeoutException = false;
							result = null;
							setTimeout(() => {
								try {
									result = doAuthenticateUserPromisified(authenticationDetails);
									loginSuccess = true;
								} catch (e) {
									timeoutException = e && e.code && e.code === "TooManyRequestsException";
									lastException = e;
									console.error(e);
								}

								if (loginSuccess) {
									resolve(result);
									return;
								} else if (!timeoutException) {
									reject(lastException);
									return;
								} else {
									//Backoff 4 Final
									setTimeout(() => {
										try {
											result = doAuthenticateUserPromisified(authenticationDetails);
											resolve(result);
										} catch (e) {
											reject(e);
										}
									}, 8000);
								}
							}, 4000);
						}
					}, 2000);
				}
			}, 1000);
		}
	});

}

function loginUser(tree = state, username, password) {
	try {
		const _username = _.toLower(username);
		logWebLoginSequence("portal.loginUser start", {
			usernamePresent: !!_username,
			passwordPresent: !!password,
			host: typeof window !== "undefined" && window.location ? window.location.hostname : "",
			userEntryPoint: state.get(["user", "entryPoint"]) || "",
			navPanelSelected: state.get(["appState", "navPanel", "selected"])
		});

		// Force USER_SRP_AUTH in case magic link was last auth method used which sets 
		// auth flow to CUSTOM_AUTH, also, reset user pool and client ID if impersonated
		// user is in different user pool
		const currentConfig = Auth.configure();
		console.log("Current config", currentConfig);

		if (currentConfig.Auth) {
			currentConfig.Auth.userPoolId = globals.cognito.userPoolId;
			currentConfig.Auth.userPoolWebClientId = globals.cognito.clientId;
		}
		currentConfig.userPoolId = globals.cognito.userPoolId;
		currentConfig.userPoolWebClientId = globals.cognito.clientId;

		Auth.configure(_.assign(currentConfig, {
			authenticationFlowType: "USER_SRP_AUTH"
		}));

		const signInResult = Auth.signIn(_username, password);
		logWebLoginSequence("portal.loginUser Auth.signIn dispatched", {
			usernamePresent: !!_username
		});
		signInResult.catch(err => {
			console.log("Login Failure", err);
			logWebLoginSequence("portal.loginUser Auth.signIn failed", {
				errorCode: err && err.code ? err.code : "",
				error: err && err.message ? err.message : `${err}`
			});
			utils.hideLoader(tree);
			let message = "Please verify your credentials and try again, you can also use the forgot password link to reset your password.";
			if (err.code && err.code === "NetworkError") {
				message = "Network connection failed, please check your internet connection and try again.";
			}
			showError("Login Unsuccessful", message);
		});
	} catch (e) {
		console.error(e);
		logWebLoginSequence("portal.loginUser failed before Auth.signIn", {
			error: e && e.message ? e.message : `${e}`
		});
		utils.hideLoader(tree);
		showError("Login Unsuccessful", "Please make sure your internet connection is working. ");
	}
}

function delay(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

async function getCurrentAuthenticatedUserAndSession() {
	const cognitoUser = await Auth.currentAuthenticatedUser();
	const session = await Auth.currentSession();
	return { cognitoUser, session };
}

async function waitForOAuthCallbackSession(maxWaitMs = 12000) {
	const startedAt = Date.now();
	let attempt = 0;
	let lastError = null;

	logWebLoginSequence("portal.waitForOAuthCallbackSession start", {
		maxWaitMs
	});

	while (Date.now() - startedAt < maxWaitMs) {
		attempt++;
		try {
			const result = await getCurrentAuthenticatedUserAndSession();
			sendDebugLogMessage("Cloud OAuth callback session became available", {
				attempt,
				waitMs: Date.now() - startedAt
			});
			logWebLoginSequence("portal.waitForOAuthCallbackSession success", {
				attempt,
				waitMs: Date.now() - startedAt
			});
			return result;
		} catch (err) {
			lastError = err;
			sendDebugLogMessage("Cloud OAuth callback session not ready yet", {
				attempt,
				waitMs: Date.now() - startedAt,
				error: err && err.message ? err.message : `${err}`
			});
			await delay(attempt < 4 ? 500 : 1000);
		}
	}

	logWebLoginSequence("portal.waitForOAuthCallbackSession timed out", {
		attempt,
		waitMs: Date.now() - startedAt,
		error: lastError && lastError.message ? lastError.message : `${lastError || ""}`
	});

	throw lastError || new Error("OAuth callback session was not available");
}

export async function restoreSession() {
	console.log("RESTORE SESSION");
	logWebLoginSequence("portal.restoreSession start", {
		hostname: window.location.hostname,
		pathname: window.location.pathname,
		searchPresent: !!window.location.search,
		hashPresent: !!window.location.hash,
		appInitialized: state.get(["appState", "initialized"]),
		needsSessionRestore: state.get(["appState", "needsSessionRestore"]),
		userLoggedIn: state.get(["user", "loggedIn"]),
		userEntryPoint: state.get(["user", "entryPoint"]) || "",
		navPanelSelected: state.get(["appState", "navPanel", "selected"])
	});
	// alert("TRY LOGGING IN");
	sendDebugLogMessage("Cloud restoreSession start", {
		hostname: window.location.hostname,
		pathname: window.location.pathname,
		search: redactAuthUrlForLog(window.location.search),
		hash: redactAuthUrlForLog(window.location.hash)
		});
		const hasOAuthCallback = hasOAuthCallbackParams();
		const nativeSsoLoginRequested = isNativeSsoLoginRequested();
		const nativeMobileAppLaunchRequested = isNativeMobileAppLaunchRequested();
		const nativeCloudPortalMode = isNativeCloudPortalMode();
		rememberNativeSsoRequestMarkers();
		// App Store 9.2 cannot send nativeSsoLogin; app-api-version is its SSO intent marker.
		const nativeLegacyMobileLaunchSsoRequested = isHcaHost()
			&& nativeMobileAppLaunchRequested
			&& !nativeSsoLoginRequested
			&& !isNativeExternalSsoCapableWebView();
		const nativeAppLaunchId = getNativeAppLaunchId();
		const newNativeMobileLaunchRequested = nativeAppLaunchId !== "";
		const shouldRestoreNativeMobileSessionBeforeAutoSso = isHcaHost() && (nativeMobileAppLaunchRequested || nativeCloudPortalMode) && !nativeSsoLoginRequested;
		if (nativeCloudPortalMode) {
			state.set(["appState", "nativeCloudPortalSessionRestoring"], true);
			state.set(["appState", "nativeCloudPortalSessionRestoreFailed"], false);
		}
		let nativeHcaAutoSignInSuppressed = isNativeHcaAutoSignInSuppressed();
	if (nativeSsoLoginRequested && nativeHcaAutoSignInSuppressed) {
		clearNativeHcaAutoSignInSuppression("explicit-native-sso-login");
		nativeHcaAutoSignInSuppressed = false;
	}
	if (hasOAuthCallback) {
		sendDebugLogMessage("Cloud restoreSession detected OAuth callback", getAuthUrlLogSummary(window.location.href));
		clearNativeHcaForceReauth("oauth-callback");
	}
	if (redirectNativeExternalSsoCallbackIfNeeded()) {
		return;
	}

	if (!isHcaHost()) {
		sendDebugLogMessage("Cloud restoreSession running on non-HCA host", {
			hostname: window.location.hostname,
			note: "HCA auto federated bypass only runs on hca.ambifi.com"
		});
	}

	if (isHcaHost()) {
		const forceLogin = utils.getLs("forceLoginV3");
		const nativeHcaLogoutCompleteAlreadyNotified = utils.getLs(HCA_NATIVE_LOGOUT_COMPLETE_NOTIFIED_LS) === "true";

		console.log("FORCE LOGIN", forceLogin);
		sendDebugLogMessage("Cloud restoreSession HCA host check", {
			forceLogin,
			hasOAuthCallback,
			nativeMobileWebView: isNativeMobileWebView(),
			nativeMobileAppLaunchRequested,
			nativeLegacyMobileLaunchSsoRequested,
			nativeCloudPortalMode,
			newNativeMobileLaunchRequested,
			appApiVersion: getLocationQueryParam("app-api-version"),
			nativeAppLaunchId,
			nativeSsoLoginRequested,
			nativeSsoLoginRequestId: getLocationQueryParam("nativeSsoLoginRequestId"),
			nativeHcaAutoSignInSuppressed,
			nativeHcaLogoutCompleteAlreadyNotified,
			shouldRestoreNativeMobileSessionBeforeAutoSso
		});
		logWebLoginSequence("portal.restoreSession HCA host check", {
			forceLogin,
			hasOAuthCallback,
			nativeMobileWebView: isNativeMobileWebView(),
			nativeMobileAppLaunchRequested,
			nativeLegacyMobileLaunchSsoRequested,
			nativeCloudPortalMode,
			newNativeMobileLaunchRequested,
			nativeAppLaunchId,
			nativeSsoLoginRequested,
			nativeHcaAutoSignInSuppressed,
			nativeHcaLogoutCompleteAlreadyNotified,
			shouldRestoreNativeMobileSessionBeforeAutoSso
		});
		if (!hasOAuthCallback && nativeHcaAutoSignInSuppressed) {
			notifyNativeHcaLogoutComplete("native-hca-auto-sso-suppressed");
		}
		if (!nativeCloudPortalMode && !hasOAuthCallback && !nativeHcaAutoSignInSuppressed && (!shouldRestoreNativeMobileSessionBeforeAutoSso || (nativeLegacyMobileLaunchSsoRequested && !newNativeMobileLaunchRequested))) {
			setNativeHcaSsoRedirectPending(true, "Preparing HCA single sign-on...", {
				source: "restoreSession-hca-host-check",
				forceLogin
			});
		}

		if (!nativeCloudPortalMode && !hasOAuthCallback && !nativeHcaAutoSignInSuppressed && !shouldRestoreNativeMobileSessionBeforeAutoSso && (nativeSsoLoginRequested || forceLogin === null || forceLogin !== "false")) {
			try {
				// Do this prior to trying to check the users session
				state.set(["restoreSession"], false);

				await handleConfigureAmplify();

				//Auth.federatedSignIn();
				sendDebugLogMessage("Cloud restoreSession auto federated sign-in on HCA host", {
					hostname: window.location.hostname,
					forceLogin
				});
				logWebLoginSequence("portal.restoreSession auto federated sign-in on HCA host", {
					forceLogin,
					nativeSsoLoginRequested,
					nativeMobileAppLaunchRequested
				});
				setNativeHcaSsoRedirectPending(true, "Opening HCA single sign-on...", {
					source: nativeSsoLoginRequested ? "hca-native-explicit-login" : (nativeMobileAppLaunchRequested ? "hca-native-mobile-app-login-load" : "hca-auto-force-login"),
					forceLogin,
					nativeSsoLoginRequested,
					nativeMobileAppLaunchRequested
				});
				startHcaFederatedSignIn({
					source: nativeSsoLoginRequested ? "hca-native-explicit-login" : (nativeMobileAppLaunchRequested ? "hca-native-mobile-app-login-load" : "hca-auto-force-login"),
					forceLogin,
					nativeSsoLoginRequested,
					nativeMobileAppLaunchRequested
				});

				utils.setLs("forceLoginV3", "false");

				return;
			} catch (e) {
				// Ok so we don't have a session, this means we have to determine what our Amplify settings are!
				state.set(["restoreSession"], false);

				console.log("No session");
				sendDebugLogMessage("Cloud restoreSession HCA host auto sign-in failed before redirect", {
					enterprise: !!state.get(["appState", "enterprise"])
				});
				logWebLoginSequence("portal.restoreSession HCA auto sign-in setup failed", {
					enterprise: !!state.get(["appState", "enterprise"]),
					error: e && e.message ? e.message : `${e}`
				});
				if (state.get(["appState", "enterprise"]) && !nativeCloudPortalMode && !hasOAuthCallback && !nativeHcaAutoSignInSuppressed && !shouldRestoreNativeMobileSessionBeforeAutoSso) {
					//Auth.federatedSignIn();
					setNativeHcaSsoRedirectPending(true, "Opening HCA single sign-on...", {
						source: "hca-auto-force-login-catch"
					});
					startHcaFederatedSignIn({
						source: "hca-auto-force-login-catch"
					});

				} else {
					setNativeHcaSsoRedirectPending(false, "", {
						source: "hca-auto-force-login-catch-no-enterprise"
					});
					utils.hideLoader(state);
					state.set(["appState", "initialized"], true);
				}

				return;
			}
		}
	}

	state.set(["appState", "needsSessionRestore"], false);

	try {
		// Do this prior to trying to check the users session
		await handleConfigureAmplify();

		const shouldWaitForNativeExternalSsoCallbackSession = hasOAuthCallback && hasNativeExternalSsoStateMarker();
		const authSession = shouldWaitForNativeExternalSsoCallbackSession
			? await waitForOAuthCallbackSession()
			: await getCurrentAuthenticatedUserAndSession();
		let cognitoUser = authSession.cognitoUser;// userPool.getCurrentUser();
		console.log("restoreSession, HAVE A SESSION");
		let session = authSession.session;

		console.log("restoreSession, session validity: " + session.isValid());

		const username = cognitoUser.username;
		const rememberMe = utils.getLs(username + ";rememberMe");
		const pendingOrigin = _.toString(utils.getLs("origin") || "").trim();
		const currentRequestedPath = `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`;
		const isDeepLinkLaunchPath = (path) => (
			_.isString(path) &&
			path !== "" &&
			(path.indexOf("/activity/") === 0 || path.indexOf("/player/") === 0)
		);
		const reuseExistingSessionForLaunch = (
			session.isValid() &&
			(isDeepLinkLaunchPath(pendingOrigin) || isDeepLinkLaunchPath(currentRequestedPath))
		);
		console.log("restoreSession, got user", cognitoUser);
		const restore = session.isValid() && (rememberMe || reuseExistingSessionForLaunch);

			console.log("restoreSession, restore flags", {
				rememberMe,
				pendingOrigin,
				currentRequestedPath,
				reuseExistingSessionForLaunch,
				restore
			});
			logWebLoginSequence("portal.restoreSession restore flags", {
				rememberMe: !!rememberMe,
				pendingOrigin,
				currentRequestedPath,
				reuseExistingSessionForLaunch,
				restore,
				enterprise: !!state.get(["appState", "enterprise"]),
				nativeCloudPortalMode
			});
			sendDebugLogMessage("Cloud restoreSession evaluated restore flags", {
			hostname: window.location.hostname,
			enterprise: !!state.get(["appState", "enterprise"]),
			rememberMe,
			pendingOrigin,
			currentRequestedPath,
			reuseExistingSessionForLaunch,
			restore
		});

		if (!nativeCloudPortalMode) {
			sendRestoreSession(restore);
		} else {
			sendDebugLogMessage("Cloud restoreSession kept native cloud portal in web mode", {
				restore,
				hostname: window.location.hostname
			});
		}

			if (!state.get(["appState", "enterprise"]) && (!restore || state.get(["inviteMember", "inviteCode"]))) {
				state.set(["appState", "initialized"], true);
				console.log("restoreSession, not restoring this session", rememberMe, restore, state.get(["inviteMember", "inviteCode"]));
				sendDebugLogMessage("Cloud restoreSession decided not to restore existing session", {
					rememberMe,
				restore,
				inviteCodePresent: !!state.get(["inviteMember", "inviteCode"]),
				enterprise: !!state.get(["appState", "enterprise"]),
				hostname: window.location.hostname
			});
			//return Promise.resolve();
			if (session.isValid()) {
				Auth.signOut();
			}
			utils.hideLoader(state);
				} else {
				// utils.showLoader(state);
					const restorePathname = _.toString(_.get(window, "location.pathname", ""));
					const remoteAuthPath = restorePathname === "/auth" || restorePathname.indexOf("/auth/") === 0;
					const securityContextPath = restorePathname === "/security-context" || restorePathname.indexOf("/security-context/") === 0;
					if ((remoteAuthPath && window.location.href.indexOf("/authenticate-magic-link") === -1) || securityContextPath) {
						try {
							await handleRemotePlayerAuth(session);
						} catch (e) {
							console.log("ERROR", e);
						}
					} else {
						logWebLoginSequence("portal.restoreSession invoking post-auth", {
							restore,
							currentRequestedPath,
							pendingOrigin,
							userEntryPoint: state.get(["user", "entryPoint"]) || ""
						});
						await handlePostAuthenticateV2(session, cognitoUser, state, username);
						if (nativeCloudPortalMode) {
						state.set(["appState", "nativeCloudPortalSessionRestoring"], false);
						state.set(["appState", "nativeCloudPortalSessionRestoreFailed"], false);
					}
					setNativeHcaSsoRedirectPending(false, "", {
						source: "existing-session-restore"
					});
				}
			}
		} catch (e) {
			// Ok so we don't have a session, this means we have to determine what our Amplify settings are!
			sendDebugLogMessage("Cloud restoreSession no current session", {
				hostname: window.location.hostname,
				enterprise: !!state.get(["appState", "enterprise"]),
				error: e && e.message ? e.message : `${e}`
			});
			logWebLoginSequence("portal.restoreSession no current session", {
				enterprise: !!state.get(["appState", "enterprise"]),
				hasOAuthCallback,
				nativeCloudPortalMode,
				nativeHcaAutoSignInSuppressed,
				error: e && e.message ? e.message : `${e}`
			});
			if (!nativeCloudPortalMode) {
				sendRestoreSession(false);
			}
			if (nativeCloudPortalMode) {
				state.set(["appState", "nativeCloudPortalSessionRestoring"], false);
				state.set(["appState", "nativeCloudPortalSessionRestoreFailed"], true);
			}
			console.log("No session");
		const forceLogin = utils.getLs("forceLoginV3");
		const nativeNoSessionAutoSsoAllowed = !nativeCloudPortalMode && (!isHcaHost() || !isNativeMobileWebView() || nativeSsoLoginRequested || nativeLegacyMobileLaunchSsoRequested || forceLogin === null || forceLogin !== "false");
		if (state.get(["appState", "enterprise"]) && !nativeCloudPortalMode && !hasOAuthCallback && !nativeHcaAutoSignInSuppressed && (!shouldRestoreNativeMobileSessionBeforeAutoSso || nativeLegacyMobileLaunchSsoRequested) && nativeNoSessionAutoSsoAllowed) {
			//Auth.federatedSignIn();
			logWebLoginSequence("portal.restoreSession no-session auto federated sign-in", {
				nativeLegacyMobileLaunchSsoRequested,
				nativeNoSessionAutoSsoAllowed,
				forceLogin
			});
			setNativeHcaSsoRedirectPending(true, "Opening HCA single sign-on...", {
				source: nativeLegacyMobileLaunchSsoRequested ? "enterprise-no-current-session-native-legacy-launch" : "enterprise-no-current-session"
			});
			startHcaFederatedSignIn({
				source: nativeLegacyMobileLaunchSsoRequested ? "enterprise-no-current-session-native-legacy-launch" : "enterprise-no-current-session",
				nativeLegacyMobileLaunchSsoRequested
			});

		} else {
			setNativeHcaSsoRedirectPending(false, "", {
				source: "no-current-session-no-auto-sso"
			});
			sendDebugLogMessage("Cloud restoreSession skipped auto SSO after no current session", {
				hostname: window.location.hostname,
				enterprise: !!state.get(["appState", "enterprise"]),
				hasOAuthCallback,
				nativeMobileWebView: isNativeMobileWebView(),
				nativeSsoLoginRequested,
				nativeMobileAppLaunchRequested,
				nativeLegacyMobileLaunchSsoRequested,
				nativeCloudPortalMode,
				nativeHcaAutoSignInSuppressed,
				shouldRestoreNativeMobileSessionBeforeAutoSso,
				nativeNoSessionAutoSsoAllowed,
				forceLogin
			});
			logWebLoginSequence("portal.restoreSession no-session skipped auto SSO", {
				enterprise: !!state.get(["appState", "enterprise"]),
				hasOAuthCallback,
				nativeMobileWebView: isNativeMobileWebView(),
				nativeSsoLoginRequested,
				nativeMobileAppLaunchRequested,
				nativeLegacyMobileLaunchSsoRequested,
				nativeCloudPortalMode,
				nativeHcaAutoSignInSuppressed,
				shouldRestoreNativeMobileSessionBeforeAutoSso,
				nativeNoSessionAutoSsoAllowed,
				forceLogin
			});
			if (nativeHcaAutoSignInSuppressed) {
				sendDebugLogMessage("Cloud restoreSession skipped HCA auto SSO because native logout suppression is active", {
					hostname: window.location.hostname
				});
			}
			utils.hideLoader(state);
			state.set(["appState", "initialized"], true);
		}
	}
}

export async function handleRemotePlayerAuth(session) {
	const authParams = getQueryStringParam("auth");
	let _authParams = validateAndParseAuthParams(authParams);

	const loginResult = session;
	const {
		authCode,
		tmpCredentialsFilename,
		useOneTimeCodeFlow
	} = getRemotePlayerAuthContext(_authParams);
	const fedTokenEndpoint = `${env.apiGateway.baseUrl}${env.apiGateway.endpoints.auth}`;
	const fedTokenRequestBody = useOneTimeCodeFlow ? {} : { tmpCredentialsFilename };

	const _fedTokenResponse = await request.post(fedTokenEndpoint)
		.set({ Authorization: loginResult.idToken.jwtToken, "Content-Type": "application/json" })
		.send(JSON.stringify(fedTokenRequestBody));

	const fedTokenResponse = _fedTokenResponse.body;
	AWS.config.credentials = new AWS.Credentials(fedTokenResponse.body.accessKeyId, fedTokenResponse.body.secretAccessKey, fedTokenResponse.body.sessionToken);
	// console.log("Got:", userData);


	const { redirectUri } = _authParams;
	let _redirectUri = redirectUri;

	const identityId = _.get(loginResult, "idToken.payload.sub", null);


	const authCallback = {
		success: true,
		tmpCredentials: fedTokenResponse.body,
		tmpCredentialsFilename,
		tmpCredentialsBucket: env.s3.tmpCredentialsBucket
	};

	const authPayload = {
		success: true,
		loginResult,
		tokens: {
			id: loginResult.idToken.jwtToken,
			refresh: loginResult.refreshToken.token
		},
		fedTokenResponse,
		fedTokenEndpoint,
		cognito: {
			ClientId: globals.cognito.clientId
		},
		identityId
	};

	await cacheRemotePlayerAuthPayload(tmpCredentialsFilename, authPayload, loginResult.idToken.jwtToken, {
		allowDirectS3Fallback: !useOneTimeCodeFlow
	});

	if (useOneTimeCodeFlow) {
		_redirectUri = appendQueryParam(redirectUri, "authCode", authCode);
	} else {
		_redirectUri = appendQueryParam(redirectUri, "authCallbackV2", encode(btoa(JSON.stringify(authCallback))));
	}
	utils.hideLoader(state);
	window.location.href = `${_redirectUri}`; // eslint-disable-line require-atomic-updates
	return loginResult;
}

// function getLcOrgs() {

// }

// function fetchOrgConfiguration() {

// }

async function handleConfigureAmplify() {
	const host = window.location.hostname;
	const subDomain = host.split(".")[0];
	state.set(["appState", "subDomain"], subDomain);
	logWebLoginSequence("portal.handleConfigureAmplify start", {
		host,
		subDomain,
		enterprise: !!state.get(["appState", "enterprise"])
	});
	sendDebugLogMessage("Cloud handleConfigureAmplify start", {
		host,
		subDomain
	});
	// const lastOrgConfig = getLastLoginOrg();
	let amplifyConfig = null;

	if (isNaN(subDomain.charAt(0)) && !subDomain.startsWith("172") && subDomain !== "dev-app" && subDomain !== "app" && subDomain !== "localhost" && subDomain !== "local") {
		// TODO Custom!

		// if (lastOrgConfig && lastOrgConfig.domain === subDomain && lastOrgConfig.enterprise_userPoolConfiguration && _.isString(lastOrgConfig.enterprise_userPoolConfiguration)) {
		// 	// Got it!
		// 	try {
		// 		amplifyConfig = JSON.parse(lastOrgConfig.enterprise_userPoolConfiguration);
		// 		console.log("No need to fetch config, had it locally:", amplifyConfig);
		// 	} catch (e) {
		// 		console.error("Failed to parse enterprise login configuration", e);
		// 	}
		// } else {
		// Fetch it!
		const res = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.userInitAuthGetOrgLoginInfo(subDomain)}`);
			const orgLoginInfo = res.body;
			if (orgLoginInfo.enterprise === 1) {
				state.set(["appState", "enterprise"], true);
			}
			console.log("Needed to fetch login config:", orgLoginInfo);
			logWebLoginSequence("portal.handleConfigureAmplify org login info", {
				host,
				subDomain,
				enterprise: orgLoginInfo.enterprise === 1,
				hasEnterpriseUserPoolConfiguration: !!orgLoginInfo.enterprise_userPoolConfiguration
			});
			sendDebugLogMessage("Cloud handleConfigureAmplify fetched org login info", {
			host,
			subDomain,
			enterprise: orgLoginInfo.enterprise === 1,
			hasEnterpriseUserPoolConfiguration: !!orgLoginInfo.enterprise_userPoolConfiguration
		});
		if (orgLoginInfo.enterprise_userPoolConfiguration) {

			try {
				amplifyConfig = JSON.parse(orgLoginInfo.enterprise_userPoolConfiguration);
			} catch (e) {
				console.error("Failed to parse enterprise login configuration", e);
			}


		}
		// }

	} else {
		// Check and see if we have previous orgs that are custom and need redirected
		// if (lastOrgConfig && lastOrgConfig.domain && lastOrgConfig.enterprise === 1) {
		// 	window.location.href = `https://${lastOrgConfig.domain}.ambifi.com`;
		// 	return;
		// } else {
		// All good, normal login!

		console.log("Globals cognito", globals.cognito);
		sendDebugLogMessage("Cloud handleConfigureAmplify using default host config", {
			host,
			subDomain,
			defaultHostFlow: true
		});

		amplifyConfig = {
			identityPoolId: globals.cognito.identityPoolId,
			// REQUIRED - Amazon Cognito Region
			region: "us-east-1",
			// OPTIONAL - Amazon Cognito User Pool ID
			userPoolId: globals.cognito.userPoolId,
			// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
			userPoolWebClientId: globals.cognito.clientId,
			// OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
			mandatorySignIn: true
		};
	}

		if (amplifyConfig) {
			amplifyConfig = configureNativeSsoUrlOpener(amplifyConfig);

			console.log("Configuring Amplify", amplifyConfig);
			logWebLoginSequence("portal.handleConfigureAmplify configuring Amplify", {
				host,
				subDomain,
				hasConfig: true,
				hasUserPoolId: !!amplifyConfig.userPoolId,
				hasIdentityPoolId: !!amplifyConfig.identityPoolId
			});
			await new Promise((resolve) => {
				setTimeout(() => {
					Amplify.configure({
						Auth: amplifyConfig
					});
					console.log("(Done) Configuring Amplify");
					logWebLoginSequence("portal.handleConfigureAmplify configured Amplify", {
						host,
						subDomain
					});
					resolve();
				}, 1000);
			});


	} else {
		console.log("Not configuring Amplify, no config");
	}
}

function resetSessionScopedState() {
	resetStreamChatUnreadRefreshState();
	clearMultiTabAuthoringGuard();
	resetEditorSessionState(state);
	resetDrive();
	state.set(["orgs"], []);
	state.set(["selectedOrg"], {});
	state.set(["activities"], []);
	state.unset(["activitiesMap"]);
	state.set(["recent"], []);
	state.set(["recentActivityCache"], {});
	state.set(["assignmentsHealthStream"], []);
	state.set(["appState", "activitySharesAi"], {});
	state.set(["appState", "chatConnected"], false);
	state.set(["appState", "streamChat", "genericUnreadMessagesCount"], null);
	state.set(["appState", "streamChat", "jobUnreadMessagesCount"], null);
	state.set(["appState", "streamChat", "jobUnreadByInstanceId"], null);
	state.set(["appState", "streamChat", "unreadMessagesCount"], 0);
	state.set(["appState", "streamChat", "unreadChannelsCount"], 0);
	state.set(PlayerPaths.ACTIVITIES, []);
	state.set(PlayerPaths.SESSIONS, {});
	state.set(PlayerPaths.ACTIVITIES_LOADED, false);
}

export function clearUser() {
	state.set(["user", "loggedIn"], false);
	resetSessionScopedState();
	// Clear impersonation flag
	utils.removeSs("impersonate");

	try {
		if (AWS.config.credentials && AWS.config.credentials.clearCachedId) {
			AWS.config.credentials.clearCachedId();
		}
		if (window.credentials && window.credentials.clearCachedId) {
			window.credentials.clearCachedId();
		}
	} catch (e) {
		console.error("Failed to clear cached identity id.", e);
	}
}

export async function logoutUser(redirect = true) {

	try {
		if (state.get(["user", "chatEnabled"])) {
			await chatClient.disconnectUser();
		}
	} catch (err) {
		console.log("Error", err);
	}

	try {
		deleteLastLoginOrg();
		resetSessionScopedState();
				state.set(["appState", "initialized"], false);
				state.set(["appState", "needsSessionRestore"], true);
				state.set(["appState", "nativeHcaSsoRedirectPending"], false);
				const suppressNativeHcaAutoSignIn = suppressNativeHcaAutoSignInAfterLogout("portal-logout");
				utils.removeSs("impersonate");
				sendDebugLogMessage("Cloud portal logout sending logout to native", {
					username: state.get(["user", "username"]) || "",
					suppressNativeHcaAutoSignIn
				});
				sendLogoutMessage("web-portal-logout", {
					username: state.get(["user", "username"]) || "",
					suppressNativeHcaAutoSignIn
				});
				handleLogout();
				await Auth.signOut();

			utils.hideLoader(state);
			if (redirect && !suppressNativeHcaAutoSignIn) {
				setTimeout(function () {
					browserHistory.push(globals.routes.login);
				}, 1000);
			} else if (suppressNativeHcaAutoSignIn) {
				sendDebugLogMessage("Cloud portal logout skipped login redirect for native HCA WebView", {
					redirectRequested: redirect
				});
			}
		} catch (error) {
		console.log("error signing out: ", error);
	}


}

export function removeDevice(deviceKey) {

	refreshCredentials(true).then(({ cognitoUser }) => {
		let devices = [];
		let devicesBlacklist = [];
		cognitoUser.getUserAttributes(async (err, result) => {

			if (err) {
				showError("User Attributes", err);
				return;
			}
			for (let i = 0; i < result.length; i++) {
				if (result[i].getName() === "custom:devices") {
					devices = JSON.parse(result[i].getValue());
				} else if (result[i].getName() === "custom:devicesBlacklist") {
					devicesBlacklist = JSON.parse(result[i].getValue());
				}
			}

			if (devices.length > 0) {
				let index = -1;
				for (let i = 0; i < devices.length; i++) {
					let device = devices[i];
					if (device.deviceId === deviceKey) {
						index = i;
					}
				}

				devices.splice(index, 1);
				updateAttribute(cognitoUser, "custom:devices", devices);

				devicesBlacklist.push(deviceKey);
				updateAttribute(cognitoUser, "custom:devicesBlacklist", devicesBlacklist);

				state.set(["devices"], devices);
				//state.set(["devicesBlacklist"], devicesBlacklist);
				// Need to post this to mobile app
			}
		});

	}).catch((err) => {
		console.error(err);
		showError("Remove Device", err.message);
	});
}

export function removeDevice2(deviceKey) {
	// Set the region where your identity pool exists (us-east-1, eu-west-1)
	AWS.config.region = "us-east-1";

	// Configure the credentials provider to use your identity pool
	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: globals.cognito.identityPoolId,
	});

	// Make the call to obtain credentials
	AWS.config.credentials.get(function () {

		let user = state.get(["user"]);
		let event = {
			username: user.username,
			deviceKey: deviceKey
		};

		let lambda = new AWS.Lambda({ region: "us-east-1", apiVersion: "2015-03-31" });
		let params = {
			FunctionName: "forgetDevice",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify(event)
		};

		lambda.invoke(params, function (error) {
			let index = -1;
			if (error) {
				alert(error.message);
			} else {
				let devices = state.get(["devices"]);
				for (let i = 0; i < devices.length; i++) {
					let device = devices[i];
					if (device.DeviceKey === deviceKey) {
						index = i;
					}
				}

				state.splice(["devices"], [index, 1]);
			}
		});
	});
}

export function sendMagicLink(email) {
	return new Promise((resolve, reject) => {
		const currentConfig = Auth.configure();
		//const baseUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
		const baseUrl = utils.getAppBaseUrl();
		request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.generateMagicLink}`)
			.set({ "Content-Type": "application/json" })
			.send(JSON.stringify({
				email,
				userPoolId: currentConfig.userPoolId,
				baseUrl
			})).then(res => {

				console.log("Fetched orgs", res.body);
				resolve();
			}).catch(err => {
				console.error(err);
				reject(err);
			});

	});
}

export function sendPublicationMagicLink({ email, publicationUrl, activityId, orgId }) {
	return new Promise((resolve, reject) => {
		const endpoint = env.apiGateway.endpoints.generateMagicLinkToPublication || "/ml/generate-magic-link-to-publication";
		request.post(`${env.apiGateway.baseUrl}${endpoint}`)
			.set({ "Content-Type": "application/json" })
			.send(JSON.stringify({
				email,
				publicationUrl,
				activityId,
				orgId
			})).then(res => {
				resolve(res.body);
			}).catch(err => {
				console.error(err);
				reject(err);
			});
	});
}

export function sendActivityMagicLink({ email, activityId, orgId }) {
	return new Promise((resolve, reject) => {
		const endpoint = env.apiGateway.endpoints.generateMagicLinkToActivity || "/ml/generate-magic-link-to-activity";
		const baseUrl = utils.getAppBaseUrl();
		const mobileRedirect = `ambifi://activity/${activityId}`;
		request.post(`${env.apiGateway.baseUrl}${endpoint}`)
			.set({ "Content-Type": "application/json" })
			.send(JSON.stringify({
				email,
				activityId,
				orgId,
				baseUrl,
				mobileRedirect
			})).then(res => {
				resolve(res.body);
			}).catch(err => {
				console.error(err);
				reject(err);
			});
	});
}

export async function handleCustomSignIn(usernameOrEmail, challengeResponse, userPoolId, userPoolWebClientId, canonicalUsername = null) {
	console.log("Handling custom sign in");
	const currentConfig = Auth.configure();
	const effectiveUserPoolId = userPoolId || currentConfig.userPoolId || (currentConfig.Auth && currentConfig.Auth.userPoolId);
	const effectiveClientId = userPoolWebClientId || currentConfig.userPoolWebClientId || (currentConfig.Auth && currentConfig.Auth.userPoolWebClientId);
	const signInUsername = canonicalUsername || usernameOrEmail;

	if (!effectiveUserPoolId || !effectiveClientId) {
		console.error("Magic link auth missing pool configuration", {
			userPoolId,
			userPoolWebClientId,
			currentConfig,
			canonicalUsername,
			usernameOrEmail
		});
		showError("Magic Link Sign-In", "Unable to authenticate: missing user pool configuration. Please request a new magic link or try again.");
		return;
	}

	const nextConfig = _.assign({}, currentConfig, {
		userPoolId: effectiveUserPoolId,
		userPoolWebClientId: effectiveClientId,
		authenticationFlowType: "CUSTOM_AUTH",
		Auth: _.assign({}, currentConfig.Auth, {
			userPoolId: effectiveUserPoolId,
			userPoolWebClientId: effectiveClientId
		})
	});

	Auth.configure(nextConfig);

	console.log("Current config", currentConfig);

	const ensureSession = async (userCandidate) => {
		if (userCandidate && typeof userCandidate.getSession === "function") {
			try {
				return await new Promise((resolve, reject) => {
					userCandidate.getSession((err, session) => err ? reject(err) : resolve(session));
				});
			} catch (_e) { /* ignore */ }
		}
		try {
			return await Auth.currentSession();
		} catch (_e) {
			return null;
		}
	};

	// If a session already exists, reuse it when it's the same user; otherwise sign out first
	try {
		const existingUser = await Auth.currentAuthenticatedUser();
		if (existingUser) {
			const existingUsername = existingUser.username ? existingUser.username.toLowerCase() : null;
			const existingEmail = (existingUser.attributes && existingUser.attributes.email ? existingUser.attributes.email : "").toLowerCase();
			const requestedUsername = signInUsername.toLowerCase();
			const requestedEmail = (usernameOrEmail || "").toLowerCase();

			if (existingUsername === requestedUsername || (requestedEmail && existingEmail === requestedEmail)) {
				console.log("Reusing existing session for magic link user");
				const session = existingUser.signInUserSession || await ensureSession(existingUser);
				await handlePostAuthenticateV2(session, existingUser, state, signInUsername);
				return existingUser;
			}

			console.log("Signing out different existing user before magic link sign-in", existingUsername);
			await Auth.signOut();
			state.set(["user", "loggedIn"], false);
		}
	} catch (_e) {
		// no existing user
	}

	return Auth.signIn(signInUsername, null)
		.then(async user => {
			let authedUser = user;
			if (user.challengeName === "CUSTOM_CHALLENGE") {
				authedUser = await Auth.sendCustomChallengeAnswer(user, challengeResponse);
			}
			// Ensure session is established
			const session = authedUser.signInUserSession || await ensureSession(authedUser);
			const currentUser = authedUser || await Auth.currentAuthenticatedUser();
			// Persist remember-me so session restore won't auto-sign-out
			state.set(["user", "rememberMe"], true);
			utils.setLs(`${currentUser.username};rememberMe`, true);
			// Run post-auth initialization to set app state
			await handlePostAuthenticateV2(session, currentUser, state, signInUsername);
			return currentUser;
		})
		.catch(err => {
			console.log(err);
			throw err;
		});
}

export async function fetchOrgInfo(jwt) {
	let orgInfo = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.user.orgInfo}`)
		.set("Authorization", jwt)
		.set({ "Accept": "application/json" });

	return uncompressResult(orgInfo.body).orgs;
}

export async function fetchDrive2(jwt) {
	// Let's fetch in two steps for a bit more scalability
	let drive = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.user.drive}`)
		.set("Authorization", jwt)
		.set({ "Accept": "application/json" });

	drive = uncompressResult(drive.body);

	let driveMap = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.user.driveMap}`)
		.set("Authorization", jwt)
		.set({ "Accept": "application/json" });

	driveMap = uncompressResult(driveMap.body);

	// Merge the two requests
	let retDrive = {
		tree: drive.drive,
		objectGuidToObject: driveMap.drive
	};

	return retDrive;
}

export async function fetchDrive(jwt) {
	const drive = await fetchDriveTree("tree", false, true);

	return drive;
}

export async function fetchInventory(jwt, playlistId) {
	let inventory = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.user.inventory}${(playlistId && playlistId !== "") ? ("?playlistId=" + playlistId) : ""}`)
		.set("Authorization", jwt)
		.set({ "Accept": "application/json" });

	//console.log("Inventory", JSON.stringify(uncompressResult(inventory.body), null, 4));
	return uncompressResult(inventory.body);
}
